import { getDataColumnsForScheme } from 'Utils/formatting.js';
import counterpart from "counterpart";
import { alphaNumeric, numeric, decimalNumber } from 'Utils/validationUtils';
import { VITE_isIE } from 'Constants/appEnvConstants';

export function getOverviewData(isOp1) {
  return [
    {
      id: 1,
      title: 'Dispute Overview',
      defaultIsVisible: true,
      isExpandable: false,
      dataColumns: [
        {
          description: 'Case Stage Stage Id',
          name: 'Case Stage Stage Id',
          displayType: 'CASE_STAGE_STAGE_ID',
          columnKey: {value1: isOp1 ? 'caseDetail.disputeStageName' : 'caseStageDetail.disputeStageName', value2: 'caseStageDetail.caseStageId', index: 15},
          nameKeyObj: {value1: 'Case Stage', value2: 'Stage ID'},
          KeyValueArr: [{key: 'Case Stage', value: isOp1 ? 'caseDetail.disputeStageName' : 'caseStageDetail.disputeStageName', index: 10}]
        },
        {
          description: 'Card Number',
          name: 'Card Number',
          displayType: 'CARDTYPE_ACCOUNTNUMBER',
          columnKey: { value1: 'caseStageDetail.cardBrandCode', value2: 'caseDetail.maskedCardNumber', value3: 'caseDetail.globalToken' },
        },
        {
          description: 'Dispute Amount',
          name: 'Dispute Amount',
          displayType: 'CURRENCY_UNIT',
          columnKey: { value1: isOp1 ? 'caseDetail.disputeAmount' : 'caseStageDetail.disputeAmount', value2: isOp1 ? 'caseDetail.currencyCode' : 'caseStageDetail.disputeCurrencyDesc' },
        },
        {
          description: 'Card Brand Central Processing Date',
          showDescription: true,
          name: 'Card Brand CPD',
          displayType: 'DATE',
          columnKey: 'caseStageDetail.caseReceivedDate',
        },
        {
          description: 'Reason Code',
          name: 'Reason Code',
          displayType: 'reason_code_with_description',
          columnKey: isOp1 ? 'caseDetail.disputeReasonCode' : 'caseStageDetail.disputeReasonCode',
          columnKeyDescription: 'caseStageDetail.codeDescription',
          descriptionKey: 'caseStageDetail.disputeCategoryName',
        },
        {
          description: 'Action Category',
          name: 'Action Category',
          displayType: 'CURRENCY_UNIT',
          columnKey: 'caseStageDetail.actionCategoryDesc',
        },
        {
          description: 'Disposition Category',
          name: 'Disposition Category',
          displayType: 'CURRENCY_UNIT',
          columnKey: 'caseStageDetail.dispositionCategoryDesc',
        },
        {
          description: 'Disposition',
          name: 'Disposition',
          displayType: 'DISPOSITION_CODE_DESC',
          dispositionActivityCode: 'caseStageDetail.dispositionActivityCode',
          dispositionActionCode: 'caseStageDetail.dispositionActionCode',
          columnKey: { value1: 'caseStageDetail.dispositionActivityDescription', value2: 'caseStageDetail.dispositionActionDescription' },
        },
      ],
    },
    {
      id: 2,
      title: 'Transaction Overview',
      defaultIsVisible: true,
      isExpandable: false,
      dataColumns: [
        {
          description: 'ARN',
          name: 'ARN',
          displayType: 'STRING',
          columnKey: 'caseDetail.acquirerReferenceNumber',
        },
        {
          description: 'Authorized',
          name: 'Authorized',
          displayType: 'DATE_AMOUNT',
          columnKey: { value1: 'authorizationDetail.authorizationDate', value2: 'authorizationDetail.authorizationAmount', value3: 'authorizationDetail.authorizationCurrencyDesc' },
        },
        {
          description: 'Settled',
          name: 'Settled',
          displayType: 'DATE_AMOUNT',
          columnKey: { value1: 'transactionDetail.transactionDate', value2: 'transactionDetail.transactionAmount', value3: 'transactionDetail.transactionCurrencyDesc' },
        },
        {
          description: 'Auth Code CARD ORIGIN',
          name: 'Auth Code CARD ORIGIN',
          displayType: 'CARD_ORIGIN_AUTH_CODE',
          columnKey: {value1: 'transactionDetail.foreignDomesticInd', value2: 'transactionDetail.authorizationCode', index: 5},
          nameKeyObj: {value1: 'Card Origin', value2: 'Auth Code'},
          KeyValueArr: [{key: 'Card Origin', value: 'transactionDetail.foreignDomesticInd', index: 1}]
        },
        {
          description: 'POS Code Transaction Code',
          name: 'POS Code Transaction Code',
          displayType: 'POS_Code_Transaction_Code',
          columnKey: {value1: 'transactionDetail.posEntryMode', value2: 'transactionDetail.transactionCode', description: 'transactionDetail.transactionCodeDesc', index: 6},
          nameKeyObj: {value1: 'POS Entry Mode', value2: 'Txn Code'},
          KeyValueArr: [{key: 'POS Entry Mode', value: 'transactionDetail.posEntryMode', description: 'transactionDetail.posEntryModeDesc', index: 2}]
        },
        {
          description: 'ECI/UCAF TEC',
          name: 'ECI/UCAF TEC',
          displayType: 'Ucaf_Tec',
          columnKey: {value1: 'transactionDetail.terminalCapacityInd', value2: 'transactionDetail.universalCardholderAuthenticationFieldInd', value3: 'transactionDetail.motoEcInd', description: '', index: 7},
          nameKeyObj: {value1: 'TEC Code', value2: 'ECI/UCAF'},
          KeyValueArr: [{key: 'TEC Code', value: 'transactionDetail.terminalCapacityInd', description: 'transactionDetail.terminalCapabilitiesDesc', index: 3}]
        },
        {
          description: 'AVS CHID',
          name: 'AVS CHID',
          displayType: 'Avs_Chid',
          columnKey: {value1: 'transactionDetail_avsCode', value2: 'transactionDetail.cardholderIdMethod', description: 'transactionDetail.cardHoderIdmethodDesc', index: 8},
          nameKeyObj: {value1: 'AVS Code', value2: 'CH ID Method'},
          KeyValueArr: [{key: 'AVS Code', value: 'transactionDetail.avsCode', description: 'transactionDetail.avsCodeDesc', index: 4}]
        },
        {
          description: 'Txn MCC',
          name: 'Txn MCC',
          displayType: 'STRING',
          columnKey: 'transactionDetail.mcc',
        }
      ],
    },
    {
      id: 3,
      title: 'Merchant Overview',
      defaultIsVisible: true,
      isExpandable: true,
      dataColumns: [
        {
          description: 'Merchant Number',
          name: 'Merchant Number',
          displayType: 'MERCHANTNUMBER',
          columnKey: isOp1 ? 'caseDetail.merchantNumber' :'merchantDetail.merchantNumber',
        },
        {
          description: 'DBA Name',
          name: 'DBA Name',
          displayType: 'STRING',
          columnKey: 'merchantDetail.dbaName',
        },
        {
          description: 'Hierarchy',
          name: 'Hierarchy',
          displayType: 'HIERARCHY',
          columnKey: 'merchantDetail.hierarchyNumber',
        },
        {
          description: 'Merchant Account Status',
          name: 'Merchant Account Status',
          displayType: 'STRING',
          columnKey: 'merchantDetail.merchantAccountStatus',
        },
        {
          description: 'CB/RR Delivery Method',
          name: 'CB/RR Delivery Method',
          displayType: 'STRING',
          columnKey: 'merchantDetail.deliveryMethod'
        },
        {
          description: 'Merchant Langauge',
          name: 'Merchant Langauge',
          displayType: 'STRING', 
          columnKey: 'merchantDetail.languageIndCode',
        },
        {
          description: 'Store Number',
          name: 'Store Number',
          displayType: 'STRING',
          columnKey: 'merchantDetail.userStoreNumber',
        },
        {
          description: 'HPY Petro Name',
          name: 'HPY Petro Name',
          displayType: 'STRING',
          columnKey: 'merchantDetail.hpyPetroName',
        },
        {
          description: 'Merchant MCC',
          name: 'Merchant MCC',
          displayType: 'STRING',
          columnKey: 'merchantDetail.mcc',
        },
        {
          description: 'MccDescription',
          name: '',
          displayType: 'STRING',
          columnKey: 'merchantDetail.mccDescription',
        },
      ],
    },
    {
      id: 4,
      defaultIsVisible: false,
      title: 'Incoming Dispute Data',
      isExpandable: false,
      dataColumns: [
        {
          description: 'Scheme Case Number',
          name: 'Scheme Case Number',
          displayType: 'STRING',
          columnKey: 'caseStageDetail.cardBrandCaseNumber',
        },
        {
          description: 'Document Indicator',
          name: 'Document Indicator',
          displayType: 'INDICATOR',
          supportDocumentInd: '',
          columnKey: 'caseStageDetail.supportDocumentInd',
        },
        {
          description: 'Transaction Indicator',
          name: 'Transaction Indicator',
          displayType: 'STRING',
          columnKey: 'transactionIndicator',
        },
        {
          description: 'Filename of Dispute Received',
          name: 'Filename of Dispute Received',
          displayType: 'FILENAME',
          columnKey: 'caseStageDetail.fileName',
        },
        {
          description: 'Scheme Respond by Date',
          name: 'Scheme Respond by Date',
          displayType: 'DATE',
          columnKey: 'caseStageDetail.cardBrandRespondDueDate',
        },
        {
          description: 'Member Message Text',
          name: 'Member Message Text',
          displayType: 'INCOMING_MMT',
          columnKey: 'caseStageDetail.memberMessageText',
        },
      ],
    },
    {
      id: 5,
      defaultIsVisible: false,
      title: 'Banking Data',
      isExpandable: true,
      dataColumns: [
        {
          description: 'Bank Name',
          name: 'Bank Name',
          displayType: 'STRING',
          columnKey: 'bankDetail.bankName',
        },
        {
          description: 'Issuer BIN/ICA',
          name: 'Issuer BIN/ICA',
          displayType: 'STRING',
          columnKey: 'bankDetail.issuerBinIca',
        },
        {
          description: 'Issuer Address',
          name: 'Issuer Address',
          displayType: 'STRING',
          columnKey: 'bankDetail.issuerAddress',
        },
        {
          description: 'Phone Number',
          name: 'Phone Number',
          displayType: 'STRING',
          columnKey: 'bankDetail.phoneNumber',
        },
        {
          description: 'Fax Number',
          name: 'Fax Number',
          displayType: 'STRING',
          columnKey: 'bankDetail.faxNumber',
        },
        {
          description: 'Email Address',
          name: 'Email Address',
          displayType: 'STRING',
          columnKey: 'bankDetail.emailAddress',
        },
      ],
    },
    {
      id: 6,
      defaultIsVisible: false,
      title: 'Accounting Data',
      isExpandable: true,
      dataColumns: [
        {
          description: 'Case Stage',
          name: 'Case Stage',
          displayType: 'STRING',
          columnKey: 'disputeStageName',
        },
        {
          description: 'Adjustment Date',
          name: 'Adjustment Date',
          displayType: 'DATE',
          columnKey: 'adjustmentDate',
        },
        {
          description: 'Delay Debit',
          name: 'Delay Debit',
          displayType: 'STRING',
          columnKey: 'delayDebit',
        },
        {
          displayType: 'account-ledgers',
          
        },
      ],
    },
  ];
}

export function getSummaryData() {
  return {
    summaryColumns: [
      {
        description: 'Reason Code',
        name: 'Reason Code',
        displayType: 'RC',
        columnKey: 'caseStageDetail.disputeReasonCode',
        descriptionKey: 'caseStageDetail.codeDescription',
      },
      {
        description: 'Status',
        name: 'Status',
        displayType: 'STRING',
        columnKey: 'caseStageDetail.statusName',
      },
      {
        description: 'ARN',
        name: 'ARN',
        displayType: 'STRING',
        columnKey: 'caseDetail.acquirerReferenceNumber',
      },
      {
        description: 'Dispute Amount',
        name: 'Dispute Amount',
        displayType: 'CURRENCY_UNIT',
        columnKey: { value1: 'caseStageDetail.disputeAmount', value2: 'caseDetail.disputeCurrencyCodeDesc' },
      },
      {
        description: 'Merchant Due Date',
        name: 'Merchant Due Date',
        displayType: 'DATE',
        columnKey: 'caseStageDetail.cardBrandRespondDueDate',
        descriptionKey: 'merchantDueDate',
      },
      {
        description: 'Card Brand Due Date',
        name: 'Card Brand Due Date',
        displayType: 'DATE',
        columnKey: 'caseStageDetail.cardBrandRespondDueDate',
        descriptionKey: 'cardbrandDueDate',
      }
    ],
  };
}

export function getSelectionActionList(permission) {
  var shortCutStyle = `color:#595959;float:right;display:inline - flex`;
  return [

    { id: '1', viewCode: 'NRD', value: 'Notify & Request Docs', text: `Notify & Request Docs <strong style=${shortCutStyle}>CTRL+ALT+N</strong>`, color: '#007dc3' },
    { id: '2', viewCode: 'RAI', value: 'Request Additional Info', text: `Request Additional Info<strong style=${shortCutStyle}>CTRL+ALT+A</strong>`, color: '#007dc3' },
    { id: '3', viewCode: 'RTI', value: 'Respond to Issuer', text: `Respond to Issuer<strong style=${shortCutStyle}>CTRL+ALT+R</strong>`, color: '#007dc3' },
    { id: '4', viewCode: 'UTD', value: 'Unable to Defend/Pursue', text: `Unable to Defend/Pursue <strong style=${shortCutStyle}>CTRL+ALT+U</strong>`, color: '#007dc3' },
    permission !== undefined && permission !== null && permission.case.canPendCase && { id: '10', viewCode: 'PC', value: 'Pend Case', text: `Pend Case <strong style=${shortCutStyle}>CTRL+ALT+P</strong>`, color: '#007dc3' },
    permission !== undefined && permission !== null && permission.case.canWriteOffCase && { id: '6', viewCode: 'WOG', value: 'Write off or Goodwill', text: `Write off or Goodwill <strong style=${shortCutStyle}>CTRL+ALT+W</strong>`, color: '#007dc3' },
    { id: '7', viewCode: 'CC', value: 'Close Case', text: `Close Case <strong style=${shortCutStyle}>CTRL+ALT+C</strong>`, color: '#007dc3' },
    permission !== undefined && permission !== null && permission.case.canAddNotes && { id: '8', viewCode: 'ADCN', value: 'Add Case Notes', text: `Add Case Notes <strong style=${shortCutStyle}>CTRL+ALT+E</strong>`, color: '#007dc3' },
    permission !== undefined && permission !== null && permission.case.canForwardCase && { id: '12', viewCode: 'TC', value: 'Transfer Case', text: `Transfer Case <strong style=${shortCutStyle}>CTRL+ALT+T</strong>`, color: '#007dc3' },
    { id: '13', viewCode: 'UTF', value: 'Unable to Fulfill', text: `Unable to Fulfill <strong style=${shortCutStyle}>CTRL+ALT+O</strong>`, color: '#007dc3' },
    { id: '14', viewCode: 'RTCB', value: 'Respond to Card Brand', text: `Respond to Card Brand <strong style=${shortCutStyle}>CTRL+ALT+B</strong>`, color: '#007dc3' },
    { id: '101', viewCode: 'UPDC', value: 'Upload Document', text: `Upload Document <strong style=${shortCutStyle}>CTRL+ALT+D</strong>`, color: '#007dc3' },
    { id: '102', viewCode: 'CD', value: 'Create Document', text: `Create Document <strong style=${shortCutStyle}>CTRL+ALT+J</strong>`, color: '#007dc3' },
    { id: '15', viewCode: 'EC', value: 'Exit Case', text: `Exit Case`, color: '#007dc3' },
    { id: '16', viewCode: 'PCF', value: 'Pursue Case Filing', text: `Pursue Case Filing <strong style=${shortCutStyle}>CTRL+ALT+S</strong>`, color: '#007dc3' },
    { id: '17', viewCode: 'MP', value: 'Manually Processed', text: `Manually Processed<strong style=${shortCutStyle}>CTRL+ALT+M</strong>`, color: '#007dc3' },
    { id: '18', viewCode: 'RID', value: 'Request Issuer Docs', text: `Request Issuer Docs<strong style=${shortCutStyle}>CTRL+ALT+I</strong>`, color: '#007dc3' },
  ];
}
export function getActionPanelDetailToShow() {
  return [
    { id: '2', viewCode: 'RAI', actionType: 'REQUESTADDINFO', url: 'api/v1/disputecasedata/issuer/', isVisible: true, extraStyle: {}, extraPrimaryButtonClass: 'next-step-button', showProgressButton: true, actionPrimaryButtonText: 'Next Step', actionDescription: 'sample Action description' },
    { id: '3', viewCode: 'RTI', actionType: 'RESPONSETOISSUER', url: 'api/v1/disputecasedata/issuer/', isVisible: true, extraStyle: {}, extraPrimaryButtonClass: 'next-step-button', showProgressButton: true, actionPrimaryButtonText: 'Next Step', actionDescription: 'sample Action description' },
    { id: '4', viewCode: 'UTD', actionType: 'UNABLETODEFENDPERSUE', url: '', isVisible: true, extraStyle: {}, extraPrimaryButtonClass: 'next-step-button', showProgressButton: true, actionPrimaryButtonText: 'Next Step', actionDescription: 'sample Action description' },
    { id: '6', viewCode: 'WOG', actionType: 'WRITEOFFGOODWILL', url: '', isVisible: true, extraStyle: {}, extraPrimaryButtonClass: 'next-step-button', showProgressButton: true, actionPrimaryButtonText: 'Next Step', actionDescription: 'sample Action description' },
    { id: '10', viewCode: 'PC', actionType: 'PENDCASE', url: 'api/v1/disputecasedata/case/stage/pend', isVisible: true, extraStyle: VITE_isIE ? { width: 260 } : { width: 300 }, extraPrimaryButtonClass: '', showProgressButton: false, actionPrimaryButtonText: 'Pend Case', actionDescription: 'sample Action description', actionSelectionList: [{ value: false, text: 'Internal Notes' }, { value: true, text: 'External Notes' }] },
    { id: '7', viewCode: 'CC', actionType: 'CLOSECASE', url: 'api/v1/disputecasedata/case/', isVisible: true, extraStyle: VITE_isIE ? { width: 260 } : { width: 280 }, extraPrimaryButtonClass: 'next-step-button', showProgressButton: true, actionPrimaryButtonText: 'Close Case', actionDescription: 'sample Action description', actionSelectionList: [{ value: false, text: 'Internal' }, { value: true, text: 'External' }] },
    { id: '8', viewCode: 'ADCN', actionType: 'ADDNOTE', url: 'api/v1/disputecasedata/case/note', isVisible: true, extraStyle: VITE_isIE ? { width: 260 } : { width: 300 }, extraPrimaryButtonClass: '', showProgressButton: false, actionPrimaryButtonText: 'Submit', actionDescription: 'sample Action description', actionSelectionList: [{ value: false, text: 'Internal' }, { value: true, text: 'External' }] },
    { id: '1', viewCode: 'NRD', actionType: 'NOTIFYANDREQUESTDOC', url: 'api/v1/disputecasedata/issuer/', isVisible: true, extraStyle: {}, extraPrimaryButtonClass: 'next-step-button', showProgressButton: true, actionPrimaryButtonText: 'Next Step', actionDescription: 'sample Action description' },
    { id: '12', viewCode: 'TC', actionType: 'TRANSFERCASE', url: 'api/v1/disputecasedata/case/stage/transfer', isVisible: true, extraStyle: {}, extraPrimaryButtonClass: '', showProgressButton: false, actionPrimaryButtonText: 'Transfer', actionDescription: 'sample Action description' },
    { id: '13', viewCode: 'UTF', actionType: 'UNABLETOFULFILL', url: 'api/v1/disputecasedata/case/stage/transfer', isVisible: true, extraStyle: {}, extraPrimaryButtonClass: 'next-step-button', showProgressButton: true, actionPrimaryButtonText: 'Next Step', actionDescription: 'sample Action description' },
    { id: '14', viewCode: 'RTCB', actionType: 'RESPONSETOCARDBRAND', url: '', isVisible: true, extraStyle: {}, extraPrimaryButtonClass: 'next-step-button', showProgressButton: true, actionPrimaryButtonText: 'Next Step', actionDescription: 'sample Action description' },
    { id: '101', viewCode: 'UPDC', actionType: 'UPLOAD_DOC', url: '', isVisible: true, extraStyle: {}, extraPrimaryButtonClass: 'next-step-button', showProgressButton: false, actionPrimaryButtonText: 'Next Step', actionDescription: 'sample Action description' },
    { id: '102', viewCode: 'CD', actionType: 'CREATEDOCUMENT', url: '', isVisible: true, extraStyle: {}, extraPrimaryButtonClass: 'next-step-button', showProgressButton: false, actionPrimaryButtonText: 'Next Step', actionDescription: 'sample Action description' },
    { id: '16', viewCode: 'PCF', actionType: 'PURSUECASEFILING', url: 'api/v1/disputecasedata/issuer/', isVisible: true, extraStyle: {}, extraPrimaryButtonClass: 'next-step-button', showProgressButton: true, actionPrimaryButtonText: 'Next Step', actionDescription: 'sample Action description' },
    { id: '17', viewCode: 'MP', actionType: 'MANUALLYPROCESSED', url: '' },
    { id: '18', viewCode: 'RID', actionType: 'REQUESTISSUERDOC', url: '', isVisible: true, extraStyle: isIE ? { width: 260 } : { width: 300 }, extraPrimaryButtonClass: '', showProgressButton: false, actionPrimaryButtonText: 'Submit', actionDescription: 'sample Action description', actionSelectionList: [{ value: false, text: 'Internal' }, { value: true, text: 'External' }] },
  ];
}

export function getUpdatedSelectionActionList(permission) {
  var shortCutStyle = `color:#595959;float:right;display:inline - flex`;
  return [
    { id: '1', viewCode: 'NRD', value: 'Notify & Request Docs', text: `Notify & Request Docs <strong style=${shortCutStyle}>CTRL+ALT+N</strong>`, color: '#007dc3' },
    { id: '2', viewCode: 'RAI', value: 'Request Additional Info', text: `Request Additional Info<strong style=${shortCutStyle}>CTRL+ALT+A</strong>`, color: '#007dc3' },
    { id: '3', viewCode: 'RTI', value: 'Respond to Issuer', text: `Respond to Issuer<strong style=${shortCutStyle}>CTRL+ALT+R</strong>`, color: '#007dc3' },
    { id: '4', viewCode: 'UTD', value: 'Unable to Defend/Pursue', text: `Unable to Defend/Pursue <strong style=${shortCutStyle}>CTRL+ALT+U</strong>`, color: '#007dc3' },
    permission !== undefined && permission !== null && permission.case.canPendCase && { id: '11', viewCode: 'UPC', value: 'Unpend Case', text: `Unpend Case <strong style=${shortCutStyle}>CTRL+ALT+Q</strong>`, color: '#007dc3' },
    permission !== undefined && permission !== null && permission.case.canWriteOffCase && { id: '6', viewCode: 'WOG', value: 'Write off or Goodwill', text: `Write off or Goodwill <strong style=${shortCutStyle}>CTRL+ALT+W</strong>`, color: '#007dc3' },
    { id: '7', viewCode: 'CC', value: 'Close Case', text: `Close Case <strong style=${shortCutStyle}>CTRL+ALT+C</strong>`, color: '#007dc3' },
    permission !== undefined && permission !== null && permission.case.canAddNotes && { id: '8', viewCode: 'ADCN', value: 'Add Case Notes', text: `Add Case Notes <strong style=${shortCutStyle}>CTRL+ALT+E</strong>`, color: '#007dc3' },
    permission !== undefined && permission !== null && permission.case.canForwardCase && { id: '12', viewCode: 'TC', value: 'Transfer Case', text: `Transfer Case <strong style=${shortCutStyle}>CTRL+ALT+T</strong>`, color: '#007dc3' },
    { id: '13', viewCode: 'UTF', value: 'Unable to Fulfill', text: `Unable to Fulfill <strong style=${shortCutStyle}>CTRL+ALT+F</strong>`, color: '#007dc3' },
    { id: '14', viewCode: 'RTCB', value: 'Respond to Card Brand', text: `Respond to Card Brand <strong style=${shortCutStyle}>CTRL+ALT+S</strong>`, color: '#007dc3' },
    { id: '101', viewCode: 'UPDC', value: 'Upload Document', text: `Upload Document <strong style=${shortCutStyle}>CTRL+ALT+D</strong>`, color: '#007dc3' },    
    { id: '102', viewCode: 'CD', value: 'Create Document', text: `Create Document <strong style=${shortCutStyle}>CTRL+ALT+J</strong>`, color: '#007dc3' },    
    { id: '15', viewCode: 'EC', value: 'Exit Case', text: `Exit Case`, color: '#007dc3' },
    { id: '16', viewCode: 'PCF', value: 'Pursue Case Filing',  text:  `Pursue Case Filing <strong style=${shortCutStyle}>CTRL+ALT+S</strong>`, color: '#007dc3' },
    { id: '17', viewCode: 'MP', value: 'Manually Processed', text: `Manually Processed<strong style=${shortCutStyle}>CTRL+ALT+M</strong>`, color: '#007dc3' },
    { id: '18', viewCode: 'RID', value: 'Request Issuer Docs', text: `Request Issuer Docs<strong style=${shortCutStyle}>CTRL+ALT+I</strong>`, color: '#007dc3' },
  ];
}
export function getOutgoingArbitrationProsaList(permission) {
  var shortCutStyle = `color:#595959;float:right;display:inline - flex`;
  return [
    permission !== undefined && permission !== null && permission.case.canPendCase && { id: '11', viewCode: 'UPC', value: 'Unpend Case', text: `Unpend Case <strong style=${shortCutStyle}>CTRL+ALT+Q</strong>`, color: '#007dc3' },
    ];
}
export function getOutgoingArbitrationProsaListShow() {
  return [
    { id: '11', viewCode: 'UPC', actionType: 'UNPENDCASE', url: 'api/v1/disputecasedata/case/stage/pend' },
 ];
}
export function getUpdatedActionPanelDetailToShow() {
  return [
    { id: '2', viewCode: 'RAI', actionType: 'REQUESTADDINFO', url: 'api/v1/disputecasedata/issuer/', isVisible: true, extraStyle: {}, extraPrimaryButtonClass: 'next-step-button', showProgressButton: true, actionPrimaryButtonText: 'Next Step', actionDescription: 'sample Action description' },
    { id: '3', viewCode: 'RTI', actionType: 'RESPONSETOISSUER', url: 'api/v1/disputecasedata/issuer/', isVisible: true, extraStyle: {}, extraPrimaryButtonClass: 'next-step-button', showProgressButton: true, actionPrimaryButtonText: 'Next Step', actionDescription: 'sample Action description' },
    { id: '4', viewCode: 'UTD', actionType: 'UNABLETODEFENDPERSUE', url: '', isVisible: true, extraStyle: {}, extraPrimaryButtonClass: 'next-step-button', showProgressButton: true, actionPrimaryButtonText: 'Next Step', actionDescription: 'sample Action description' },
    { id: '6', viewCode: 'WOG', actionType: 'WRITEOFFGOODWILL', url: '', isVisible: true, extraStyle: {}, extraPrimaryButtonClass: 'next-step-button', showProgressButton: true, actionPrimaryButtonText: 'Next Step', actionDescription: 'sample Action description' },
    { id: '11', viewCode: 'UPC', actionType: 'UNPENDCASE', url: 'api/v1/disputecasedata/case/stage/pend' },
    { id: '7', viewCode: 'CC', actionType: 'CLOSECASE', url: 'api/v1/disputecasedata/case/', isVisible: true, extraStyle: VITE_isIE ? { width: 260 } : { width: 280 }, extraPrimaryButtonClass: 'next-step-button', showProgressButton: true, actionPrimaryButtonText: 'Close Case', actionDescription: 'sample Action description', actionSelectionList: [{ value: false, text: 'Internal' }, { value: true, text: 'External' }] },
    { id: '8', viewCode: 'ADCN', actionType: 'ADDNOTE', url: 'api/v1/disputecasedata/case/note', isVisible: true, extraStyle: VITE_isIE ? { width: 260 } : { width: 300 }, extraPrimaryButtonClass: '', showProgressButton: false, actionPrimaryButtonText: 'Submit', actionDescription: 'sample Action description', actionSelectionList: [{ value: false, text: 'Internal' }, { value: true, text: 'External' }] },
    { id: '1', viewCode: 'NRD', actionType: 'NOTIFYANDREQUESTDOC', url: 'api/v1/disputecasedata/issuer/', isVisible: true, extraStyle: {}, extraPrimaryButtonClass: 'next-step-button', showProgressButton: true, actionPrimaryButtonText: 'Next Step', actionDescription: 'sample Action description' },
    { id: '12', viewCode: 'TC', actionType: 'TRANSFERCASE', url: 'api/v1/disputecasedata/case/stage/transfer', isVisible: true, extraStyle: {}, extraPrimaryButtonClass: '', showProgressButton: false, actionPrimaryButtonText: 'Transfer', actionDescription: 'sample Action description' },
    { id: '13', viewCode: 'UTF', actionType: 'UNABLETOFULFILL', url: 'api/v1/disputecasedata/case/stage/transfer', isVisible: true, extraStyle: {}, extraPrimaryButtonClass: 'next-step-button', showProgressButton: true, actionPrimaryButtonText: 'Next Step', actionDescription: 'sample Action description' },
    { id: '14', viewCode: 'RTCB', actionType: 'RESPONSETOCARDBRAND', url: '', isVisible: true, extraStyle: {}, extraPrimaryButtonClass: 'next-step-button', showProgressButton: true, actionPrimaryButtonText: 'Next Step', actionDescription: 'sample Action description' },
    { id: '101', viewCode: 'UPDC', actionType: 'UPLOAD_DOC', url: '', isVisible: true, extraStyle: {}, extraPrimaryButtonClass: 'next-step-button', showProgressButton: false, actionPrimaryButtonText: 'Next Step', actionDescription: 'sample Action description' },
    { id: '102', viewCode: 'CD', actionType: 'CREATEDOCUMENT', url: '', isVisible: true, extraStyle: {}, extraPrimaryButtonClass: 'next-step-button', showProgressButton: false, actionPrimaryButtonText: 'Next Step', actionDescription: 'sample Action description' },
    { id: '16', viewCode: 'PCF', actionType: 'PURSUECASEFILING', url: 'api/v1/disputecasedata/issuer/', isVisible: true, extraStyle: {}, extraPrimaryButtonClass: 'next-step-button', showProgressButton: true, actionPrimaryButtonText: 'Next Step', actionDescription: 'sample Action description' },
    { id: '17', viewCode: 'MP', actionType: 'MANUALLYPROCESSED', url: '' },
    { id: '18', viewCode: 'RID', actionType: 'REQUESTISSUERDOC', url: '', isVisible: true, extraStyle: isIE ? { width: 260 } : { width: 280 }, extraPrimaryButtonClass: '', showProgressButton: false, actionPrimaryButtonText: 'Submit', actionDescription: 'sample Action description' , actionSelectionList: [{ value: false, text: 'Internal' }, { value: true, text: 'External' }] },
  ];
}

export function getExpandedOverviewData() {
  return [
    {
      id: 5,
      defaultIsVisible: false,
      title: 'Banking Data',
      dataColumns: [
        {
          description: 'Bank Name',
          name: 'Bank Name',
          displayType: 'STRING',
          columnKey: 'bankDetail_bankName',
        },
        {
          description: 'Issuer BIN/ICA',
          name: 'Issuer BIN/ICA',
          displayType: 'STRING',
          columnKey: 'bankDetail_issuerBinIca',
        },
        {
          description: 'Issuer Address',
          name: 'Issuer Address',
          displayType: 'STRING',
          columnKey: 'bankDetail_issuerAddress',
        },
        {
          description: 'Phone Number',
          name: 'Phone Number',
          displayType: 'STRING',
          columnKey: 'bankDetail_phoneNumber',
        },
        {
          description: 'Fax Number',
          name: 'Fax Number',
          displayType: 'STRING',
          columnKey: 'bankDetail_faxNumber',
        },
        {
          description: 'Email Address',
          name: 'Email Address',
          displayType: 'STRING',
          columnKey: 'bankDetail_emailAddress',
        },
        {
          description: 'Issuer’s Contact Person',
          name: 'Issuer’s Contact Person',
          displayType: 'STRING',
          columnKey: 'bankDetail_issuerContactPerson',
        },
        {
          description: 'Region',
          name: 'Region',
          displayType: 'STRING',
          columnKey: 'bankDetail_regionCode',
        },
      ],
    },
    {
      id: 3,
      title: 'Merchant Overview',
      defaultIsVisible: true,
      dataColumns: [
        {
          description: 'Merchant Number',
          name: 'Merchant Number',
          displayType: 'MERCHANTNUMBER',
          columnKey: 'merchantDetail_merchantNumber',
        },
        {
          description: 'DBA Name',
          name: 'DBA Name',
          displayType: 'STRING',
          columnKey: 'merchantDetail_dbaName',
        },
        {
          description: 'Hierarchy',
          name: 'Hierarchy',
          displayType: 'HIERARCHY',
          columnKey: 'merchantDetail_hierarchyNumber',
        },
        {
          description: 'Merchant MCC',
          name: 'Merchant MCC',
          displayType: 'STRING',
          columnKey: 'merchantDetail_mcc',
        },
        {
          description: 'Merchant Address',
          name: 'Merchant Address',
          displayType: 'MAILINGADDRESS',
          columnKey: 'merchantDetail_merchantAddress',
        },
        {
          description: 'Merchant Langauge',
          name: 'Merchant Langauge',
          displayType: 'STRING',
          columnKey: 'merchantDetail_languageIndCode',
        },
        {
          description: 'Premier Indicator',
          name: 'Premier Indicator',
          displayType: 'STRING',
          columnKey: 'merchantDetail_premierInd',
        },
        {
          description: 'Merchant Account Status',
          name: 'Merchant Account Status',
          displayType: 'STRING',
          columnKey: 'merchantDetail_merchantAccountStatus',
        },
        {
          description: 'ISO Liability Indicator',
          name: 'ISO Liability Indicator',
          displayType: 'STRING',
          columnKey: 'merchantDetail_liabilityIndicator',
        },
        {
          description: 'CB/RR Delivery Method',
          name: 'CB/RR Delivery Method',
          displayType: 'STRING',
          columnKey: 'merchantDetail_deliveryMethod',
        },
        {
          description: 'RR Address',
          name: 'RR Address',
          displayType: 'STRING',
          columnKey: 'merchantDetail_retrievalAddressCode',
        },
        {
          description: 'CB Address',
          name: 'CB Address',
          displayType: 'STRING',
          columnKey: 'merchantDetail_chargebackAddressCode',
        },
      ],
    },
    {
      id: 6,
      defaultIsVisible: false,
      title: 'Accounting Data',
      dataColumns: [
        {
          description: 'Bank ID',
          name: 'Bank ID',
          displayType: 'STRING-BANKID',
          columnKey: 'bankId',
        },
        {
          description: 'settlementCompanyNumber',
          name: 'Company Number',
          displayType: 'STRING-COMPANYNUMBER',
          columnKey: 'settlementCompanyNumber',
        },
        {
          description: 'Transaction Type',
          name: 'Transaction Type',
          displayType: 'STRING-TRANSACTIONTYPE',
          columnKey: 'transactionType',
        },   
      ],
    },
  ];
}

export function getDrawerData(id, data) {

  return [
    {
      id: 1,
      pageId: 'case',
      isSummaryRow: true,
      isManualTransaction: true,
      isSummaryPanel: true,
      isHorizontalPanel: true,
      isFilterPane: true,
      isToggle: true,
      searchFilterName: 'case', //queue_mgmt_merchant
      dataColumns: [{ defaultIsVisible: true, isDefault: true, name: 'Acquirer BIN/ICA', displayType: 'STRING', columnKey: 'acquirerBinIca', columnId: 'acquirerBinIca', },
      { defaultIsVisible: true, isDefault: true, name: 'Acquirer Name', displayType: 'STRING', columnKey: 'acquirerName', columnId: 'acquirerName', },
      { defaultIsVisible: true, isDefault: true, name: 'Acquirer Reference Number', displayType: 'NUMBER', columnKey: 'acquirerReferenceNumber', columnId: 'acquirerReferenceNumber', },
      { defaultIsVisible: true, isDefault: true, name: 'Authorization Code', displayType: 'NUMBER', columnKey: 'authorizationCode', columnId: 'authorizationCode', },
      { defaultIsVisible: true, isDefault: true, name: 'Card Brand Code', displayType: 'card_type', columnKey: 'cardBrandCode', columnId: 'cardBrandCode', },
      { defaultIsVisible: true, isDefault: true, name: 'Card Brand Region Code', displayType: 'STRING', columnKey: 'cardBrandRegionCode', columnId: 'cardBrandRegionCode', },
      { defaultIsVisible: true, isDefault: true, name: 'Case Number', displayType: 'NUMBER', columnKey: 'caseNumber', columnId: 'caseNumber', },
      { defaultIsVisible: true, isDefault: true, name: 'Created By', displayType: 'STRING', columnKey: 'createdBy', columnId: 'createdBy', },
      { defaultIsVisible: true, isDefault: true, name: 'Created Timestamp', displayType: 'DATE', columnKey: 'createdTimestamp', columnId: 'createdTimestamp', },
      { defaultIsVisible: true, isDefault: true, name: 'Dispute Currency Code', displayType: 'STRING', columnKey: 'disputeCurrencyCode', columnId: 'disputeCurrencyCode', },
      { defaultIsVisible: true, isDefault: true, name: 'Dspt To Mrchnt Cur Exchng Rate', displayType: 'STRING', columnKey: 'dsptToMrchntCurExchngRate', columnId: 'dsptToMrchntCurExchngRate', },
      { defaultIsVisible: true, isDefault: true, name: 'Foreign Domestic Indicator', displayType: 'NUMBER', columnKey: 'foreignDomesticIndicator', columnId: 'foreignDomesticIndicator', },
      { defaultIsVisible: true, isDefault: true, name: 'Global Token', displayType: 'STRING', columnKey: 'globalToken', columnId: 'globalToken', },
      { defaultIsVisible: true, isDefault: true, name: 'Issuer Bin Ica', displayType: 'STRING', columnKey: 'issuerBinIca', columnId: 'issuerBinIca', },
      { defaultIsVisible: true, isDefault: true, name: 'Last Modified By', displayType: 'STRING', columnKey: 'lastModifiedBy', columnId: 'lastModifiedBy', },
      { defaultIsVisible: true, isDefault: true, name: 'Last Modified Timestamp', displayType: 'DATE', columnKey: 'lastModifiedTimestamp', columnId: 'lastModifiedTimestamp', },
      { defaultIsVisible: true, isDefault: true, name: 'MAS Hierarchy Id', displayType: 'NUMBER', columnKey: 'masHierarchyId', columnId: 'masHierarchyId', },
      { defaultIsVisible: true, isDefault: true, name: 'Masked Card Number', displayType: 'ACCOUNTNUMBER', columnKey: 'maskedCardNumber', columnId: 'maskedCardNumber', },
      { defaultIsVisible: true, isDefault: true, name: 'Merchant Category Code', displayType: 'STRING', columnKey: 'merchantCategoryCode', columnId: 'merchantCategoryCode', },
      { defaultIsVisible: true, isDefault: true, name: 'Merchant City', displayType: 'STRING', columnKey: 'merchantCity', columnId: 'merchantCity', },
      { defaultIsVisible: true, isDefault: true, name: 'Merchant Country Code', displayType: 'STRING', columnKey: 'merchantCountryCode', columnId: 'merchantCountryCode', },
      { defaultIsVisible: true, isDefault: true, name: 'Merchant Hierarchy Id', displayType: 'STRING', columnKey: 'merchantHeirarchyId', columnId: 'merchantHeirarchyId', },
      { defaultIsVisible: true, isDefault: true, name: 'Merchant Name', displayType: 'STRING', columnKey: 'merchantName', columnId: 'merchantName', },
      { defaultIsVisible: true, isDefault: true, name: 'Merchant Payment Currency Code', displayType: 'STRING', columnKey: 'merchantPaymentCurrencyCode', columnId: 'merchantPaymentCurrencyCode', },
      { defaultIsVisible: true, isDefault: true, name: 'Merchant Region Code', displayType: 'STRING', columnKey: 'merchantRegionCode', columnId: 'merchantRegionCode', },
      { defaultIsVisible: true, isDefault: true, name: 'Merchant Token', displayType: 'STRING', columnKey: 'merchantToken', columnId: 'merchantToken', },
      { defaultIsVisible: true, isDefault: true, name: 'Mrchnt To Dspt Cur Exchng Rate', displayType: 'STRING', columnKey: 'mrchntToDsptCurExchngRate', columnId: 'mrchntToDsptCurExchngRate', },
      { defaultIsVisible: true, isDefault: true, name: 'Settlement Bank Id', displayType: 'NUMBER', columnKey: 'settlementBankId', columnId: 'settlementBankId', },
      { defaultIsVisible: true, isDefault: true, name: 'Settlement Company Number', displayType: 'STRING', columnKey: 'settlementCompanyNumber', columnId: 'settlementCompanyNumber', },
      { defaultIsVisible: true, isDefault: true, name: 'Transaction Amount', displayType: 'CURRENCY_UNIT', columnKey: 'transactionAmount', columnId: 'transactionAmount', },
      { defaultIsVisible: true, isDefault: true, name: 'Transaction Currency Code', displayType: 'STRING', columnKey: 'transactionCurrencyCode', columnId: 'transactionCurrencyCode', },
      { defaultIsVisible: true, isDefault: true, name: 'Transaction Date', displayType: 'DATE', columnKey: 'transactionDate', columnId: 'transactionDate', },
      { defaultIsVisible: true, isDefault: true, name: 'Transaction Master Id', displayType: '', columnKey: 'transactionMasterId', columnId: 'transactionMasterId', },
      { defaultIsVisible: true, isDefault: true, name: 'Transaction Time', displayType: 'STRING', columnKey: 'transactionTime', columnId: 'transactionTime', },
      { defaultIsVisible: true, isDefault: true, name: 'Card Brand Case Number', displayType: 'NUMBER', columnKey: 'cardBrandCaseNumber', columnId: 'cardBrandCaseNumber', },
      { defaultIsVisible: true, isDefault: true, name: 'Card Brand Dispute Id', displayType: 'STRING', columnKey: 'cardBrandDisputeId', columnId: 'cardBrandDisputeId', },
      { defaultIsVisible: true, isDefault: true, name: 'Card Brand Merchant Number', displayType: 'NUMBER', columnKey: 'cardBrandMerchantNumber', columnId: 'cardBrandMerchantNumber', },
      { defaultIsVisible: true, isDefault: true, name: 'Card Brand Respond Due Date', displayType: 'DATE', columnKey: 'cardBrandRespondDueDate', columnId: 'cardBrandRespondDueDate', },
      { defaultIsVisible: true, isDefault: true, name: 'Case Received Date', displayType: 'DATE', columnKey: 'caseReceivedDate', columnId: 'caseReceivedDate', },
      { defaultIsVisible: true, isDefault: true, name: 'Case Result', displayType: 'STRING', columnKey: 'caseResult', columnId: 'caseResult', },
      { defaultIsVisible: true, isDefault: true, name: 'Case Stage Id', displayType: 'NUMBER', columnKey: 'caseStageId', columnId: 'caseStageId', },
      { defaultIsVisible: true, isDefault: true, name: 'Case Workflow Config Id', displayType: 'NUMBER', columnKey: 'caseWorkflowConfigId', columnId: 'caseWorkflowConfigId', },
      { defaultIsVisible: true, isDefault: true, name: 'Credit Debit Ind', displayType: 'STRING', columnKey: 'creditDebitInd', columnId: 'creditDebitInd', },
      { defaultIsVisible: true, isDefault: true, name: 'Credited Amount', displayType: 'CURRENCY_UNIT', columnKey: 'creditedAmount', columnId: 'creditedAmount', },
      { defaultIsVisible: true, isDefault: true, name: 'Credited Date', displayType: 'DATE', columnKey: 'creditedDate', columnId: 'creditedDate', },
      { defaultIsVisible: true, isDefault: true, name: 'Disposition Action Code', displayType: 'STRING', columnKey: 'dispositionActionCode', columnId: 'dispositionActionCode', },
      { defaultIsVisible: true, isDefault: true, name: 'Disposition Activity Code', displayType: 'STRING', columnKey: 'dispositionActivityCode', columnId: 'dispositionActivityCode', },
      { defaultIsVisible: true, isDefault: true, name: 'Dispute Amount', displayType: 'CURRENCY_UNIT', columnKey: 'disputeAmount', columnId: 'disputeAmount', },
      { defaultIsVisible: true, isDefault: true, name: 'Dispute Reason Code', displayType: 'STRING', columnKey: 'disputeReasonCode', columnId: 'disputeReasonCode', },
      { defaultIsVisible: true, isDefault: true, name: 'Dispute Source Id', displayType: 'STRING', columnKey: 'disputeSourceId', columnId: 'disputeSourceId', },
      { defaultIsVisible: true, isDefault: true, name: 'Dispute Stage Id', displayType: 'STRING', columnKey: 'disputeStageId', columnId: 'disputeStageId', },
      { defaultIsVisible: true, isDefault: true, name: 'Gl Adjust Status', displayType: 'STRING', columnKey: 'glAdjustStatus', columnId: 'glAdjustStatus', },
      { defaultIsVisible: true, isDefault: true, name: 'Delay Debit Ind', displayType: 'STRING', columnKey: 'hpyDelayDebitInd', columnId: 'hpyDelayDebitInd', },
      { defaultIsVisible: true, isDefault: true, name: 'Internal Respond Due Date', displayType: 'DATE', columnKey: 'internalRespondDueDate', columnId: 'internalRespondDueDate', },
      { defaultIsVisible: true, isDefault: true, name: 'Is Decision Confirmed Ind', displayType: 'STRING', columnKey: 'isDecisionConfirmedInd', columnId: 'isDecisionConfirmedInd', },
      { defaultIsVisible: true, isDefault: true, name: 'Latest Stage Ind', displayType: 'STRING', columnKey: 'latestStageInd', columnId: 'latestStageInd', },
      { defaultIsVisible: true, isDefault: true, name: 'Member Message Text', displayType: 'STRING', columnKey: 'memberMessageText', columnId: 'memberMessageText', },
      { defaultIsVisible: true, isDefault: true, name: 'Merchant Disposition Actn Code', displayType: 'STRING', columnKey: 'merchantDispositionActnCode', columnId: 'merchantDispositionActnCode', },
      { defaultIsVisible: true, isDefault: true, name: 'Merchant Payment Amount', displayType: 'CURRENCY_UNIT', columnKey: 'merchantPaymentAmount', columnId: 'merchantPaymentAmount', },
      { defaultIsVisible: true, isDefault: true, name: 'Merchant Respond Due Date', displayType: 'DATE', columnKey: 'merchantRespondDueDate', columnId: 'merchantRespondDueDate', },
      { defaultIsVisible: true, isDefault: true, name: 'Merchant Status Id', displayType: 'STRING', columnKey: 'merchantStatusId', columnId: 'merchantStatusId', },
      { defaultIsVisible: true, isDefault: true, name: 'Partial Indicator', displayType: 'STRING', columnKey: 'partialInd', columnId: 'partialInd', },
      { defaultIsVisible: true, isDefault: true, name: 'Pend Indicator', displayType: 'STRING', columnKey: 'pendInd', columnId: 'pendInd', },
      { defaultIsVisible: true, isDefault: true, name: 'Queue Id', displayType: 'STRING', columnKey: 'queueId', columnId: 'queueId', },
      { defaultIsVisible: true, isDefault: true, name: 'Representment Amount', displayType: 'CURRENCY_UNIT', columnKey: 'representmentAmount', columnId: 'representmentAmount', },
      { defaultIsVisible: true, isDefault: true, name: 'Response To Case Stage Id', displayType: 'STRING', columnKey: 'responseToCaseStageId', columnId: 'responseToCaseStageId', },
      { defaultIsVisible: true, isDefault: true, name: 'Stage Config Id', displayType: 'STRING', columnKey: 'stageConfigId', columnId: 'stageConfigId', },
      { defaultIsVisible: true, isDefault: true, name: 'Status Id', displayType: 'STRING', columnKey: 'statusId', columnId: 'statusId', },
      { defaultIsVisible: true, isDefault: true, name: 'Support Document Ind', displayType: 'INDICATOR', columnKey: 'supportDocumentInd', columnId: 'supportDocumentInd', },
      { defaultIsVisible: true, isDefault: true, name: 'Take Action Code', displayType: 'STRING', columnKey: 'takeActionCode', columnId: 'takeActionCode', },
      ],
      showActions: true,
      isExportable: true,
      canManageColumns: true,
      name: 'Case Data',
      detailViewTitle: 'Case Data',
      returnToText: 'Return to Case Landing Page',
      defaultSort: {
        key: 'caseNumber',
        order: 0,
      },
    },
    {
      id: 2,
      pageId: 'scheme',
      isSummaryRow: true,
      isManualTransaction: true,
      isSummaryPanel: true,
      isHorizontalPanel: true,
      isFilterPane: true,
      isToggle: true,
      searchFilterName: 'scheme', //queue_mgmt_merchant
      dataColumns: getDataColumnsForScheme(data),
      showActions: true,
      isExportable: true,
      canManageColumns: true,
      name: 'Card Brand Data',
      detailViewTitle: 'Card Brand Data',
      returnToText: 'Return to Case Landing Page',
      defaultSort: {
        key: 'caseNumber',
        order: 0,
      },
    },
    {
      id: 4,
      pageId: 'transaction',
      isSummaryRow: true,
      isManualTransaction: true,
      isSummaryPanel: true,
      isHorizontalPanel: true,
      isFilterPane: true,
      isToggle: true,
      searchFilterName: 'transaction', //queue_mgmt_merchant
      dataColumns: [{ defaultIsVisible: true, isDefault: true, name: 'Acquirer Reference Number', displayType: 'STRING', columnKey: 'arn', columnId: 'arn', },
      { defaultIsVisible: true, isDefault: true, name: 'Redacted Card Number', displayType: 'ACCOUNTNUMBER', columnKey: 'cardNumberRk', secondaryColumnKey: 'globalToken', columnId: 'cardNumberRk', },
      { defaultIsVisible: true, isDefault: true, name: 'Merchant Number', displayType: 'NUMBER', columnKey: 'merchantNumber', columnId: 'merchantNumber', },
      { defaultIsVisible: true, isDefault: true, name: 'Terminal Identifier', displayType: 'STRING', columnKey: 'terminalTid', columnId: 'terminalTid', },
      { defaultIsVisible: true, isDefault: true, name: 'Transaction Amount', displayType: 'CURRENCY_UNIT', columnKey: 'transactionAmount', columnId: 'transactionAmount', },
      { defaultIsVisible: true, isDefault: true, name: 'Currency Code', displayType: 'STRING', columnKey: 'currencyCode', columnId: 'currencyCode', },
      { defaultIsVisible: true, isDefault: true, name: 'Transaction Code', displayType: 'STRING', columnKey: 'transactionCode', columnId: 'transactionCode', },
      { defaultIsVisible: true, isDefault: true, name: 'Transaction Date', displayType: 'DATE', columnKey: 'transactionDate', columnId: 'transactionDate', },
      { defaultIsVisible: true, isDefault: true, name: 'Transaction Time', displayType: 'STRING', columnKey: 'transactionTime', columnId: 'transactionTime', },
      { defaultIsVisible: true, isDefault: true, name: 'Transaction Type', displayType: 'STRING', columnKey: 'transactionType', columnId: 'transactionType', },
      { defaultIsVisible: true, isDefault: true, name: 'Transaction Identifier', displayType: 'STRING', columnKey: 'transactionIdentifier', columnId: 'transactionIdentifier', },
      { defaultIsVisible: true, isDefault: true, name: 'Terminal Verification Result Code', displayType: 'STRING', columnKey: 'trmnlVerificationResultCode', columnId: 'trmnlVerificationResultCode', },
      { defaultIsVisible: true, isDefault: true, name: 'Authorization Amount', displayType: 'CURRENCY_UNIT', columnKey: 'authorizationAmount', columnId: 'authorizationAmount', },
      { defaultIsVisible: true, isDefault: true, name: 'Authorization Code', displayType: 'STRING', columnKey: 'authorizationCode', columnId: 'authorizationCode', },
      { defaultIsVisible: true, isDefault: true, name: 'Authorization Indicator', displayType: 'STRING', columnKey: 'authorizationInd', columnId: 'authorizationInd', },
      { defaultIsVisible: true, isDefault: true, name: 'Authorization Response Code', displayType: 'STRING', columnKey: 'authorizationResponseCode', columnId: 'authorizationResponseCode', },
      { defaultIsVisible: true, isDefault: true, name: 'Authorization Source Code', displayType: 'STRING', columnKey: 'authorizationSourceCode', columnId: 'authorizationSourceCode', },
      { defaultIsVisible: true, isDefault: true, name: 'Card Authentication Indicator', displayType: 'STRING', columnKey: 'cardAuthenticationInd', columnId: 'cardAuthenticationInd', },
      { defaultIsVisible: true, isDefault: true, name: 'Cardholder Id Method', displayType: 'STRING', columnKey: 'cardholderIdMethod', columnId: 'cardholderIdMethod', },
      { defaultIsVisible: true, isDefault: true, name: 'Cash Back Amount', displayType: 'CURRENCY_UNIT', columnKey: 'cashBackAmount', columnId: 'cashBackAmount', },
      { defaultIsVisible: true, isDefault: true, name: 'Category Indicator', displayType: 'STRING', columnKey: 'categoryInd', columnId: 'categoryInd', },
      { defaultIsVisible: true, isDefault: true, name: 'Cryptogram Code', displayType: 'STRING', columnKey: 'cryptogramCode', columnId: 'cryptogramCode', },
      { defaultIsVisible: true, isDefault: true, name: 'Cryptogram Information', displayType: 'STRING', columnKey: 'cryptogramInformation', columnId: 'cryptogramInformation', },
      { defaultIsVisible: true, isDefault: true, name: 'Cryptogram Unpredictable Nbr', displayType: 'STRING', columnKey: 'cryptogramUnpredictableNbr', columnId: 'cryptogramUnpredictableNbr', },
      { defaultIsVisible: true, isDefault: true, name: 'Currency Exponent', displayType: 'STRING', columnKey: 'currencyExponent', columnId: 'currencyExponent', },
      { defaultIsVisible: true, isDefault: true, name: 'Foreign Amount', displayType: 'CURRENCY_UNIT', columnKey: 'foreignAmount', columnId: 'foreignAmount', },
      { defaultIsVisible: true, isDefault: true, name: 'Foreign Domestic Indicator', displayType: 'STRING', columnKey: 'foreignDomesticInd', columnId: 'foreignDomesticInd', },
      { defaultIsVisible: true, isDefault: true, name: 'Invoice Number', displayType: 'NUMBER', columnKey: 'invoiceNumber', columnId: 'invoiceNumber', },
      { defaultIsVisible: true, isDefault: true, name: 'Issr Application Byte4to7 Data', displayType: 'STRING', columnKey: 'issrApplicationByte4to7Data', columnId: 'issrApplicationByte4to7Data', },
      { defaultIsVisible: true, isDefault: true, name: 'Issuer Application Byte1 Data', displayType: 'STRING', columnKey: 'issuerApplicationByte1Data', columnId: 'issuerApplicationByte1Data', },
      { defaultIsVisible: true, isDefault: true, name: 'Issuer Application Byte17 Data', displayType: 'STRING', columnKey: 'issuerApplicationByte17Data', columnId: 'issuerApplicationByte17Data', },
      { defaultIsVisible: true, isDefault: true, name: 'Issuer Application Byte2 Data', displayType: 'STRING', columnKey: 'issuerApplicationByte2Data', columnId: 'issuerApplicationByte2Data', },
      { defaultIsVisible: true, isDefault: true, name: 'Issuer Application Byte3 Data', displayType: 'STRING', columnKey: 'issuerApplicationByte3Data', columnId: 'issuerApplicationByte3Data', },
      { defaultIsVisible: true, isDefault: true, name: 'Issuer Application Byte8 Data', displayType: 'STRING', columnKey: 'issuerApplicationByte8Data', columnId: 'issuerApplicationByte8Data', },
      { defaultIsVisible: true, isDefault: true, name: 'Issuer Appln Byt18to32 Data', displayType: 'STRING', columnKey: 'issuerApplnByt18to32Data', columnId: 'issuerApplnByt18to32Data', },
      { defaultIsVisible: true, isDefault: true, name: 'Issuer Appln Byt9to16 Data', displayType: 'STRING', columnKey: 'issuerApplnByt9to16Data', columnId: 'issuerApplnByt9to16Data', },
      { defaultIsVisible: true, isDefault: true, name: 'MC Quick Payment Service Indicator', displayType: 'STRING', columnKey: 'mcQuickPaymentServiceInd', columnId: 'mcQuickPaymentServiceInd', },
      { defaultIsVisible: true, isDefault: true, name: 'Txn MCC', displayType: 'STRING', columnKey: 'mcc', columnId: 'mcc', },
      { defaultIsVisible: true, isDefault: true, name: 'MOTO Ecommerce Indicator', displayType: 'STRING', columnKey: 'motoEcInd', columnId: 'motoEcInd', },
      { defaultIsVisible: true, isDefault: true, name: 'Original Transaction Reference Number', displayType: 'STRING', columnKey: 'orgnlTransactionRefrncNbr', columnId: 'orgnlTransactionRefrncNbr', },
      { defaultIsVisible: true, isDefault: true, name: 'POS Entry Mode', displayType: 'STRING', columnKey: 'posEntryMode', columnId: 'posEntryMode', },
      { defaultIsVisible: true, isDefault: true, name: 'Recurring Payment Indicator', displayType: 'STRING', columnKey: 'recurringPayInd', columnId: 'recurringPayInd', },
      { defaultIsVisible: true, isDefault: true, name: 'Remarks', displayType: 'STRING', columnKey: 'remarks', columnId: 'remarks', },
      { defaultIsVisible: true, isDefault: true, name: 'Requested Payment Service Indicator', displayType: 'STRING', columnKey: 'requestedPaymentServiceInd', columnId: 'requestedPaymentServiceInd', },
      { defaultIsVisible: true, isDefault: true, name: 'Security Protocol', displayType: 'STRING', columnKey: 'securityProtocol', columnId: 'securityProtocol', },
      { defaultIsVisible: true, isDefault: true, name: 'Terminal Capability Profile', displayType: 'STRING', columnKey: 'terminalCapabilityProfile', columnId: 'terminalCapabilityProfile', },
      { defaultIsVisible: true, isDefault: true, name: 'Terminal Capability Indicator', displayType: 'STRING', columnKey: 'terminalCapacityInd', columnId: 'terminalCapacityInd', },
      { defaultIsVisible: true, isDefault: true, name: 'Terminal Country Code', displayType: 'STRING', columnKey: 'terminalCountryCode', columnId: 'terminalCountryCode', },
      { defaultIsVisible: true, isDefault: true, name: 'Terminal Entry Mode', displayType: 'STRING', columnKey: 'terminalEntryMode', columnId: 'terminalEntryMode', },
      { defaultIsVisible: true, isDefault: true, name: 'Terminal Transaction Date', displayType: 'DATE', columnKey: 'terminalTransactionDate', columnId: 'terminalTransactionDate', },
      { defaultIsVisible: true, isDefault: true, name: 'Universal Cardholder Auth Field Indicator', displayType: 'STRING', columnKey: 'unvrslCardhldrAuthFieldInd', columnId: 'unvrslCardhldrAuthFieldInd', },
      { defaultIsVisible: true, isDefault: true, name: 'Global Transaction Id', displayType: 'STRING', columnKey: 'globalTransactionId', columnId: 'globalTransactionId', },
      { defaultIsVisible: true, isDefault: true, name: 'Payment Currency Alpha', displayType: 'STRING', columnKey: 'paymentCurrencyAlpha', columnId: 'paymentCurrencyAlpha', },
      { defaultIsVisible: true, isDefault: true, name: 'Front End Vendor Desc', displayType: 'STRING', columnKey: 'frontEndVendorIdDesc', columnId: 'frontEndVendorIdDesc', },
      ],
      showActions: true,
      isExportable: true,
      canManageColumns: true,
      name: 'Transaction Data',
      detailViewTitle: 'Transaction Data',
      returnToText: 'Return to Case Landing Page',
      defaultSort: {
        key: 'caseNumber',
        order: 0,
      },
    },
    {
      id: 3,
      pageId: 'transaction',
      isSummaryRow: true,
      isManualTransaction: true,
      isSummaryPanel: true,
      isHorizontalPanel: true,
      isFilterPane: true,
      isToggle: true,
      searchFilterName: 'transaction', //queue_mgmt_merchant
      dataColumns: [
        { defaultIsVisible: true, isDefault: true, name: 'Redacted Card Number', displayType: 'ACCOUNTNUMBER', columnKey: 'cardNumberRk', secondaryColumnKey: 'globalToken', columnId: 'cardNumberRk', },
        { defaultIsVisible: true, isDefault: true, name: 'Merchant Number', displayType: 'NUMBER', columnKey: 'merchantNumber', columnId: 'merchantNumber', },
        { defaultIsVisible: true, isDefault: true, name: 'Terminal Identifier', displayType: 'STRING', columnKey: 'terminalId', columnId: 'terminalId', },
        { defaultIsVisible: true, isDefault: true, name: 'Authorization Amount', displayType: 'CURRENCY_UNIT', columnKey: 'authAmount', columnId: 'authAmount', },
        { defaultIsVisible: true, isDefault: true, name: 'Currency Code', displayType: 'STRING', columnKey: 'currencyCode', columnId: 'currencyCode', },
        { defaultIsVisible: true, isDefault: true, name: 'Authorization Code', displayType: 'STRING', columnKey: 'authCode', columnId: 'authCode', },
        { defaultIsVisible: true, isDefault: true, name: 'Authorization Date', displayType: 'DATE', columnKey: 'authDate', columnId: 'authDate', },
        { defaultIsVisible: true, isDefault: true, name: 'Authorization Time', displayType: 'STRING', columnKey: 'authTime', columnId: 'authTime', },
        { defaultIsVisible: true, isDefault: true, name: 'Authorization Source', displayType: 'STRING', columnKey: 'authSource', columnId: 'authSource', },
        { defaultIsVisible: true, isDefault: true, name: 'Transaction Code', displayType: 'STRING', columnKey: 'tranCode', columnId: 'tranCode', },
        { defaultIsVisible: true, isDefault: true, name: 'Transaction Description', displayType: 'STRING', columnKey: 'tranDesc', columnId: 'tranDesc', },
        { defaultIsVisible: true, isDefault: true, name: 'Transaction Identifier', displayType: 'STRING', columnKey: 'tranId', columnId: 'tranId', },
        { defaultIsVisible: true, isDefault: true, name: 'Authorization Vendor', displayType: 'STRING', columnKey: 'authVendor', columnId: 'authVendor', },
        { defaultIsVisible: true, isDefault: true, name: 'AVS Code', displayType: 'STRING', columnKey: 'avsCode', columnId: 'avsCode', },
        { defaultIsVisible: true, isDefault: true, name: 'Category Indicator', displayType: 'STRING', columnKey: 'catInd', columnId: 'catInd', },
        { defaultIsVisible: true, isDefault: true, name: 'CAVV Results', displayType: 'STRING', columnKey: 'cavvResults', columnId: 'cavvResults', },
        { defaultIsVisible: true, isDefault: true, name: 'CVV2 Results', displayType: 'STRING', columnKey: 'cvv2Results', columnId: 'cvv2Results', },
        { defaultIsVisible: true, isDefault: true, name: 'Issuer Response Code', displayType: 'STRING', columnKey: 'issuerResponseCode', columnId: 'issuerResponseCode', },
        { defaultIsVisible: true, isDefault: true, name: 'Payment Service Indicator', displayType: 'STRING', columnKey: 'payServiceInd', columnId: 'payServiceInd', },
        { defaultIsVisible: true, isDefault: true, name: 'POS Entry Mode', displayType: 'STRING', columnKey: 'posEntryMode', columnId: 'posEntryMode', },
        { defaultIsVisible: true, isDefault: true, name: 'POS Entry Mode Description', displayType: 'STRING', columnKey: 'posEntryModeDesc', columnId: 'posEntryModeDesc', },
        { defaultIsVisible: true, isDefault: true, name: 'UCAF Indicator', displayType: 'STRING', columnKey: 'ucafInd', columnId: 'ucafInd', },
        { defaultIsVisible: true, isDefault: true, name: 'Hierarchy', displayType: 'STRING', columnKey: 'hierarchy', columnId: 'hierarchy', },
      ],
      showActions: true,
      isExportable: true,
      canManageColumns: true,
      name: 'Authorization Data',
      detailViewTitle: 'Authorization Data',
      returnToText: 'Return to Case Landing Page',
      defaultSort: {
        key: 'caseNumber',
        order: 0,
      },
    },   {
      id: 5,
      pageId: 'transaction',
      isSummaryRow: true,
      isManualTransaction: true,
      isSummaryPanel: true,
      isHorizontalPanel: true,
      isFilterPane: true,
      isToggle: true,
      searchFilterName: 'transaction', //queue_mgmt_merchant
      dataColumns: [{ defaultIsVisible: true, isDefault: true, name: 'Acquirer Reference Number', displayType: 'STRING', columnKey: 'arn', columnId: 'arn', },
      { defaultIsVisible: true, isDefault: true, name: 'Redacted Card Number', displayType: 'ACCOUNTNUMBER', columnKey: 'cardNumberRk', secondaryColumnKey: 'globalToken', columnId: 'cardNumberRk', },
      { defaultIsVisible: true, isDefault: true, name: 'Merchant Number', displayType: 'NUMBER', columnKey: 'merchantNumber', columnId: 'merchantNumber', },
      { defaultIsVisible: true, isDefault: true, name: 'Terminal Identifier', displayType: 'STRING', columnKey: 'terminalTid', columnId: 'terminalTid', },
      { defaultIsVisible: true, isDefault: true, name: 'Transaction Amount', displayType: 'CURRENCY_UNIT', columnKey: 'transactionAmount', columnId: 'transactionAmount', },
      { defaultIsVisible: true, isDefault: true, name: 'Currency Code', displayType: 'STRING', columnKey: 'currencyCode', columnId: 'currencyCode', },
      { defaultIsVisible: true, isDefault: true, name: 'Transaction Code', displayType: 'STRING', columnKey: 'transactionCode', columnId: 'transactionCode', },
      { defaultIsVisible: true, isDefault: true, name: 'Transaction Date', displayType: 'DATE', columnKey: 'transactionDate', columnId: 'transactionDate', },
      { defaultIsVisible: true, isDefault: true, name: 'Transaction Time', displayType: 'STRING', columnKey: 'transactionTime', columnId: 'transactionTime', },
      { defaultIsVisible: true, isDefault: true, name: 'Transaction Type', displayType: 'STRING', columnKey: 'transactionType', columnId: 'transactionType', },
      { defaultIsVisible: true, isDefault: true, name: 'Transaction Identifier', displayType: 'STRING', columnKey: 'transactionIdentifier', columnId: 'transactionIdentifier', },
      { defaultIsVisible: true, isDefault: true, name: 'Terminal Verification Result Code', displayType: 'STRING', columnKey: 'trmnlVerificationResultCode', columnId: 'trmnlVerificationResultCode', },
      { defaultIsVisible: true, isDefault: true, name: 'Authorization Amount', displayType: 'CURRENCY_UNIT', columnKey: 'authorizationAmount', columnId: 'authorizationAmount', },
      { defaultIsVisible: true, isDefault: true, name: 'Authorization Code', displayType: 'STRING', columnKey: 'authorizationCode', columnId: 'authorizationCode', },
      { defaultIsVisible: true, isDefault: true, name: 'Authorization Indicator', displayType: 'STRING', columnKey: 'authorizationInd', columnId: 'authorizationInd', },
      { defaultIsVisible: true, isDefault: true, name: 'Authorization Response Code', displayType: 'STRING', columnKey: 'authorizationResponseCode', columnId: 'authorizationResponseCode', },
      { defaultIsVisible: true, isDefault: true, name: 'Authorization Source Code', displayType: 'STRING', columnKey: 'authorizationSourceCode', columnId: 'authorizationSourceCode', },
      { defaultIsVisible: true, isDefault: true, name: 'Card Authentication Indicator', displayType: 'STRING', columnKey: 'cardAuthenticationInd', columnId: 'cardAuthenticationInd', },
      { defaultIsVisible: true, isDefault: true, name: 'Cardholder Id Method', displayType: 'STRING', columnKey: 'cardholderIdMethod', columnId: 'cardholderIdMethod', },
      { defaultIsVisible: true, isDefault: true, name: 'Cash Back Amount', displayType: 'CURRENCY_UNIT', columnKey: 'cashBackAmount', columnId: 'cashBackAmount', },
      { defaultIsVisible: true, isDefault: true, name: 'Category Indicator', displayType: 'STRING', columnKey: 'categoryInd', columnId: 'categoryInd', },
      { defaultIsVisible: true, isDefault: true, name: 'Cryptogram Code', displayType: 'STRING', columnKey: 'cryptogramCode', columnId: 'cryptogramCode', },
      { defaultIsVisible: true, isDefault: true, name: 'Cryptogram Information', displayType: 'STRING', columnKey: 'cryptogramInformation', columnId: 'cryptogramInformation', },
      { defaultIsVisible: true, isDefault: true, name: 'Cryptogram Unpredictable Nbr', displayType: 'STRING', columnKey: 'cryptogramUnpredictableNbr', columnId: 'cryptogramUnpredictableNbr', },
      { defaultIsVisible: true, isDefault: true, name: 'Currency Exponent', displayType: 'STRING', columnKey: 'currencyExponent', columnId: 'currencyExponent', },
      { defaultIsVisible: true, isDefault: true, name: 'Foreign Amount', displayType: 'CURRENCY_UNIT', columnKey: 'foreignAmount', columnId: 'foreignAmount', },
      { defaultIsVisible: true, isDefault: true, name: 'Foreign Domestic Indicator', displayType: 'STRING', columnKey: 'foreignDomesticInd', columnId: 'foreignDomesticInd', },
      { defaultIsVisible: true, isDefault: true, name: 'Invoice Number', displayType: 'NUMBER', columnKey: 'invoiceNumber', columnId: 'invoiceNumber', },
      { defaultIsVisible: true, isDefault: true, name: 'Issr Application Byte4to7 Data', displayType: 'STRING', columnKey: 'issrApplicationByte4to7Data', columnId: 'issrApplicationByte4to7Data', },
      { defaultIsVisible: true, isDefault: true, name: 'Issuer Application Byte1 Data', displayType: 'STRING', columnKey: 'issuerApplicationByte1Data', columnId: 'issuerApplicationByte1Data', },
      { defaultIsVisible: true, isDefault: true, name: 'Issuer Application Byte17 Data', displayType: 'STRING', columnKey: 'issuerApplicationByte17Data', columnId: 'issuerApplicationByte17Data', },
      { defaultIsVisible: true, isDefault: true, name: 'Issuer Application Byte2 Data', displayType: 'STRING', columnKey: 'issuerApplicationByte2Data', columnId: 'issuerApplicationByte2Data', },
      { defaultIsVisible: true, isDefault: true, name: 'Issuer Application Byte3 Data', displayType: 'STRING', columnKey: 'issuerApplicationByte3Data', columnId: 'issuerApplicationByte3Data', },
      { defaultIsVisible: true, isDefault: true, name: 'Issuer Application Byte8 Data', displayType: 'STRING', columnKey: 'issuerApplicationByte8Data', columnId: 'issuerApplicationByte8Data', },
      { defaultIsVisible: true, isDefault: true, name: 'Issuer Appln Byt18to32 Data', displayType: 'STRING', columnKey: 'issuerApplnByt18to32Data', columnId: 'issuerApplnByt18to32Data', },
      { defaultIsVisible: true, isDefault: true, name: 'Issuer Appln Byt9to16 Data', displayType: 'STRING', columnKey: 'issuerApplnByt9to16Data', columnId: 'issuerApplnByt9to16Data', },
      { defaultIsVisible: true, isDefault: true, name: 'MC Quick Payment Service Indicator', displayType: 'STRING', columnKey: 'mcQuickPaymentServiceInd', columnId: 'mcQuickPaymentServiceInd', },
      { defaultIsVisible: true, isDefault: true, name: 'Txn MCC', displayType: 'STRING', columnKey: 'mcc', columnId: 'mcc', },
      { defaultIsVisible: true, isDefault: true, name: 'MOTO Ecommerce Indicator', displayType: 'STRING', columnKey: 'motoEcInd', columnId: 'motoEcInd', },
      { defaultIsVisible: true, isDefault: true, name: 'Original Transaction Reference Number', displayType: 'STRING', columnKey: 'orgnlTransactionRefrncNbr', columnId: 'orgnlTransactionRefrncNbr', },
      { defaultIsVisible: true, isDefault: true, name: 'POS Entry Mode', displayType: 'STRING', columnKey: 'posEntryMode', columnId: 'posEntryMode', },
      { defaultIsVisible: true, isDefault: true, name: 'Recurring Payment Indicator', displayType: 'STRING', columnKey: 'recurringPayInd', columnId: 'recurringPayInd', },
      { defaultIsVisible: true, isDefault: true, name: 'Remarks', displayType: 'STRING', columnKey: 'remarks', columnId: 'remarks', },
      { defaultIsVisible: true, isDefault: true, name: 'Requested Payment Service Indicator', displayType: 'STRING', columnKey: 'requestedPaymentServiceInd', columnId: 'requestedPaymentServiceInd', },
      { defaultIsVisible: true, isDefault: true, name: 'Security Protocol', displayType: 'STRING', columnKey: 'securityProtocol', columnId: 'securityProtocol', },
      { defaultIsVisible: true, isDefault: true, name: 'Terminal Capability Profile', displayType: 'STRING', columnKey: 'terminalCapabilityProfile', columnId: 'terminalCapabilityProfile', },
      { defaultIsVisible: true, isDefault: true, name: 'Terminal Capacity Indicator', displayType: 'STRING', columnKey: 'terminalCapacityInd', columnId: 'terminalCapacityInd', },
      { defaultIsVisible: true, isDefault: true, name: 'Terminal Country Code', displayType: 'STRING', columnKey: 'terminalCountryCode', columnId: 'terminalCountryCode', },
      { defaultIsVisible: true, isDefault: true, name: 'Terminal Entry Mode', displayType: 'STRING', columnKey: 'terminalEntryMode', columnId: 'terminalEntryMode', },
      { defaultIsVisible: true, isDefault: true, name: 'Terminal Transaction Date', displayType: 'DATE', columnKey: 'terminalTransactionDate', columnId: 'terminalTransactionDate', },
      { defaultIsVisible: true, isDefault: true, name: 'Universal Cardholder Auth Field Indicator', displayType: 'STRING', columnKey: 'unvrslCardhldrAuthFieldInd', columnId: 'unvrslCardhldrAuthFieldInd', },
      { defaultIsVisible: true, isDefault: true, name: 'Global Transaction Id', displayType: 'STRING', columnKey: 'globalTransactionId', columnId: 'globalTransactionId', },
      ],
      showActions: true,
      isExportable: true,
      canManageColumns: true,
      name: 'Transaction Data',
      detailViewTitle: 'Transaction Data',
      returnToText: 'Return to Case Landing Page',
      defaultSort: {
        key: 'caseNumber',
        order: 0,
      },
    },
    {
      id: 7,
      pageId: 'transaction',
      isSummaryRow: true,
      isManualTransaction: true,
      isSummaryPanel: true,
      isHorizontalPanel: true,
      isFilterPane: true,
      isToggle: true,
      searchFilterName: 'transaction', //queue_mgmt_merchant
      dataColumns: [{ defaultIsVisible: true, isDefault: true, name: 'Acquirer Reference Number', displayType: 'STRING', columnKey: 'arn', columnId: 'arn', },
      { defaultIsVisible: true, isDefault: true, name: 'Redacted Card Number', displayType: 'ACCOUNTNUMBER', columnKey: 'cardNumberRk', secondaryColumnKey: 'globalToken', columnId: 'cardNumberRk', },
      { defaultIsVisible: true, isDefault: true, name: 'Merchant Number', displayType: 'NUMBER', columnKey: 'merchantNumber', columnId: 'merchantNumber', },
      { defaultIsVisible: true, isDefault: true, name: 'Terminal Identifier', displayType: 'STRING', columnKey: 'terminalTid', columnId: 'terminalTid', },
      { defaultIsVisible: true, isDefault: true, name: 'Transaction Amount', displayType: 'CURRENCY_UNIT', columnKey: 'transactionAmount', columnId: 'transactionAmount', },
      { defaultIsVisible: true, isDefault: true, name: 'Currency Code', displayType: 'STRING', columnKey: 'currencyCode', columnId: 'currencyCode', },
      { defaultIsVisible: true, isDefault: true, name: 'Transaction Code', displayType: 'STRING', columnKey: 'transactionCode', columnId: 'transactionCode', },
      { defaultIsVisible: true, isDefault: true, name: 'Transaction Date', displayType: 'DATE', columnKey: 'transactionDate', columnId: 'transactionDate', },
      { defaultIsVisible: true, isDefault: true, name: 'Transaction Time', displayType: 'STRING', columnKey: 'transactionTime', columnId: 'transactionTime', },
      { defaultIsVisible: true, isDefault: true, name: 'Transaction Type', displayType: 'STRING', columnKey: 'transactionType', columnId: 'transactionType', },
      { defaultIsVisible: true, isDefault: true, name: 'Transaction Identifier', displayType: 'STRING', columnKey: 'transactionIdentifier', columnId: 'transactionIdentifier', },
      { defaultIsVisible: true, isDefault: true, name: 'Terminal Verification Result Code', displayType: 'STRING', columnKey: 'trmnlVerificationResultCode', columnId: 'trmnlVerificationResultCode', },
      { defaultIsVisible: true, isDefault: true, name: 'Authorization Amount', displayType: 'CURRENCY_UNIT', columnKey: 'authorizationAmount', columnId: 'authorizationAmount', },
      { defaultIsVisible: true, isDefault: true, name: 'Authorization Code', displayType: 'STRING', columnKey: 'authorizationCode', columnId: 'authorizationCode', },
      { defaultIsVisible: true, isDefault: true, name: 'Authorization Indicator', displayType: 'STRING', columnKey: 'authorizationInd', columnId: 'authorizationInd', },
      { defaultIsVisible: true, isDefault: true, name: 'Authorization Response Code', displayType: 'STRING', columnKey: 'authorizationResponseCode', columnId: 'authorizationResponseCode', },
      { defaultIsVisible: true, isDefault: true, name: 'Authorization Source Code', displayType: 'STRING', columnKey: 'authorizationSourceCode', columnId: 'authorizationSourceCode', },
      { defaultIsVisible: true, isDefault: true, name: 'Card Authentication Indicator', displayType: 'STRING', columnKey: 'cardAuthenticationInd', columnId: 'cardAuthenticationInd', },
      { defaultIsVisible: true, isDefault: true, name: 'Cardholder Id Method', displayType: 'STRING', columnKey: 'cardholderIdMethod', columnId: 'cardholderIdMethod', },
      { defaultIsVisible: true, isDefault: true, name: 'Cash Back Amount', displayType: 'CURRENCY_UNIT', columnKey: 'cashBackAmount', columnId: 'cashBackAmount', },
      { defaultIsVisible: true, isDefault: true, name: 'Category Indicator', displayType: 'STRING', columnKey: 'categoryInd', columnId: 'categoryInd', },
      { defaultIsVisible: true, isDefault: true, name: 'Cryptogram Code', displayType: 'STRING', columnKey: 'cryptogramCode', columnId: 'cryptogramCode', },
      { defaultIsVisible: true, isDefault: true, name: 'Cryptogram Information', displayType: 'STRING', columnKey: 'cryptogramInformation', columnId: 'cryptogramInformation', },
      { defaultIsVisible: true, isDefault: true, name: 'Cryptogram Unpredictable Nbr', displayType: 'STRING', columnKey: 'cryptogramUnpredictableNbr', columnId: 'cryptogramUnpredictableNbr', },
      { defaultIsVisible: true, isDefault: true, name: 'Currency Exponent', displayType: 'STRING', columnKey: 'currencyExponent', columnId: 'currencyExponent', },
      { defaultIsVisible: true, isDefault: true, name: 'Foreign Amount', displayType: 'CURRENCY_UNIT', columnKey: 'foreignAmount', columnId: 'foreignAmount', },
      { defaultIsVisible: true, isDefault: true, name: 'Foreign Domestic Indicator', displayType: 'STRING', columnKey: 'foreignDomesticInd', columnId: 'foreignDomesticInd', },
      { defaultIsVisible: true, isDefault: true, name: 'Invoice Number', displayType: 'NUMBER', columnKey: 'invoiceNumber', columnId: 'invoiceNumber', },
      { defaultIsVisible: true, isDefault: true, name: 'Issr Application Byte4to7 Data', displayType: 'STRING', columnKey: 'issrApplicationByte4to7Data', columnId: 'issrApplicationByte4to7Data', },
      { defaultIsVisible: true, isDefault: true, name: 'Issuer Application Byte1 Data', displayType: 'STRING', columnKey: 'issuerApplicationByte1Data', columnId: 'issuerApplicationByte1Data', },
      { defaultIsVisible: true, isDefault: true, name: 'Issuer Application Byte17 Data', displayType: 'STRING', columnKey: 'issuerApplicationByte17Data', columnId: 'issuerApplicationByte17Data', },
      { defaultIsVisible: true, isDefault: true, name: 'Issuer Application Byte2 Data', displayType: 'STRING', columnKey: 'issuerApplicationByte2Data', columnId: 'issuerApplicationByte2Data', },
      { defaultIsVisible: true, isDefault: true, name: 'Issuer Application Byte3 Data', displayType: 'STRING', columnKey: 'issuerApplicationByte3Data', columnId: 'issuerApplicationByte3Data', },
      { defaultIsVisible: true, isDefault: true, name: 'Issuer Application Byte8 Data', displayType: 'STRING', columnKey: 'issuerApplicationByte8Data', columnId: 'issuerApplicationByte8Data', },
      { defaultIsVisible: true, isDefault: true, name: 'Issuer Appln Byt18to32 Data', displayType: 'STRING', columnKey: 'issuerApplnByt18to32Data', columnId: 'issuerApplnByt18to32Data', },
      { defaultIsVisible: true, isDefault: true, name: 'Issuer Appln Byt9to16 Data', displayType: 'STRING', columnKey: 'issuerApplnByt9to16Data', columnId: 'issuerApplnByt9to16Data', },
      { defaultIsVisible: true, isDefault: true, name: 'MC Quick Payment Service Indicator', displayType: 'STRING', columnKey: 'mcQuickPaymentServiceInd', columnId: 'mcQuickPaymentServiceInd', },
      { defaultIsVisible: true, isDefault: true, name: 'Txn MCC', displayType: 'STRING', columnKey: 'mcc', columnId: 'mcc', },
      { defaultIsVisible: true, isDefault: true, name: 'MOTO Ecommerce Indicator', displayType: 'STRING', columnKey: 'motoEcInd', columnId: 'motoEcInd', },
      { defaultIsVisible: true, isDefault: true, name: 'Original Transaction Reference Number', displayType: 'STRING', columnKey: 'orgnlTransactionRefrncNbr', columnId: 'orgnlTransactionRefrncNbr', },
      { defaultIsVisible: true, isDefault: true, name: 'POS Entry Mode', displayType: 'STRING', columnKey: 'posEntryMode', columnId: 'posEntryMode', },
      { defaultIsVisible: true, isDefault: true, name: 'Recurring Payment Indicator', displayType: 'STRING', columnKey: 'recurringPayInd', columnId: 'recurringPayInd', },
      { defaultIsVisible: true, isDefault: true, name: 'Remarks', displayType: 'STRING', columnKey: 'remarks', columnId: 'remarks', },
      { defaultIsVisible: true, isDefault: true, name: 'Requested Payment Service Indicator', displayType: 'STRING', columnKey: 'requestedPaymentServiceInd', columnId: 'requestedPaymentServiceInd', },
      { defaultIsVisible: true, isDefault: true, name: 'Security Protocol', displayType: 'STRING', columnKey: 'securityProtocol', columnId: 'securityProtocol', },
      { defaultIsVisible: true, isDefault: true, name: 'Terminal Capability Profile', displayType: 'STRING', columnKey: 'terminalCapabilityProfile', columnId: 'terminalCapabilityProfile', },
      { defaultIsVisible: true, isDefault: true, name: 'Terminal Capacity Indicator', displayType: 'STRING', columnKey: 'terminalCapacityInd', columnId: 'terminalCapacityInd', },
      { defaultIsVisible: true, isDefault: true, name: 'Terminal Country Code', displayType: 'STRING', columnKey: 'terminalCountryCode', columnId: 'terminalCountryCode', },
      { defaultIsVisible: true, isDefault: true, name: 'Terminal Entry Mode', displayType: 'STRING', columnKey: 'terminalEntryMode', columnId: 'terminalEntryMode', },
      { defaultIsVisible: true, isDefault: true, name: 'Terminal Transaction Date', displayType: 'DATE', columnKey: 'terminalTransactionDate', columnId: 'terminalTransactionDate', },
      { defaultIsVisible: true, isDefault: true, name: 'Universal Cardholder Auth Field Indicator', displayType: 'STRING', columnKey: 'unvrslCardhldrAuthFieldInd', columnId: 'unvrslCardhldrAuthFieldInd', },
      { defaultIsVisible: true, isDefault: true, name: 'Global Transaction Id', displayType: 'STRING', columnKey: 'globalTransactionId', columnId: 'globalTransactionId', },
      ],
      showActions: true,
      isExportable: true,
      canManageColumns: true,
      name: 'Transaction Data',
      detailViewTitle: 'Transaction Data',
      returnToText: 'Return to Case Landing Page',
      defaultSort: {
        key: 'caseNumber',
        order: 0,
      },
    },
    {
      id: 6,
      pageId: 'questionnaire',
      isSummaryRow: true,
      isManualTransaction: true,
      isSummaryPanel: true,
      isHorizontalPanel: true,
      isFilterPane: true,
      isToggle: true,
      searchFilterName: 'questionnaire', 
           dataColumns: [{ defaultIsVisible: true, isDefault: true, name: 'Reason Response', displayType: 'STRING', columnKey: 'ResponseReason', columnId: 'ResponseReason', },
      { defaultIsVisible: true, isDefault: true, name: 'Attach Documents', displayType: 'BOOLEAN', columnKey: 'AttachDocuments', columnId: 'AttachDocuments', },
      { defaultIsVisible: true, isDefault: true, name: 'Dispute Reason Explained', displayType: 'TEXT', columnKey: 'DisputeReasonExpl', columnId: 'DisputeReasonExpl', },
      { defaultIsVisible: true, isDefault: true, name: 'Reason Not Accept Liability', displayType: 'TEXT', columnKey: 'ResonNotAcceptLiability', columnId: 'ResonNotAcceptLiability', },
      { defaultIsVisible: true, isDefault: true, name: 'Credit Proceed Date', displayType: 'TEXT', columnKey: 'CreditProceedDate', columnId: 'CreditProceedDate', },
      { defaultIsVisible: true, isDefault: true, name: 'Credit Reversal Option', displayType: 'TEXT', columnKey: 'CreditReversalOption', columnId: 'CreditReversalOption', },
      { defaultIsVisible: true, isDefault: true, name: 'Credit Amount', displayType: 'NUMBER', columnKey: 'CreditAmount', columnId: 'CreditAmount', },
      { defaultIsVisible: true, isDefault: true, name: 'Credit Not Apply Reason', displayType: 'TEXT', columnKey: 'CRNotApplyReason', columnId: 'crNotApplyReason', },
      { defaultIsVisible: true, isDefault: true, name: 'Arn CR Date', displayType: 'TEXT', columnKey: 'ProvideArnCRDate', columnId: 'ProvideArnCRDate', },
      { defaultIsVisible: true, isDefault: true, name: 'Correct Transaction Date', displayType: 'TEXT', columnKey: 'TransDate', columnId: 'TransDate', },
      { defaultIsVisible: true, isDefault: true, name: 'Cancellation Date', displayType: 'TEXT', columnKey: 'CancellationDate', columnId: 'CancellationDate', },
      { defaultIsVisible: true, isDefault: true, name: 'Authorization Date', displayType: 'TEXT', columnKey: 'AuthorizationDate', columnId: 'AuthorizationDate', },
      { defaultIsVisible: true, isDefault: true, name: 'Brief Invalid Reason ID', displayType: 'TEXT', columnKey: 'briefInvalidReasonID', columnId: 'briefInvalidReasonID', },
      { defaultIsVisible: true, isDefault: true, name: 'Credit Arn', displayType: 'NUMBER', columnKey: 'CreditArn', columnId: 'CreditArn', }, 
      { defaultIsVisible: true, isDefault: true, name: 'Destination Wallet Address', displayType: 'TEXT', columnKey: 'DestinationWalletAddress', columnId: 'DestinationWalletAddress', },   
      { defaultIsVisible: true, isDefault: true, name: 'Blockchain Transaction Hash', displayType: 'TEXT', columnKey: 'BlockchainTransactionHash', columnId: 'BlockchainTransactionHash', },   
      { defaultIsVisible: true, isDefault: true, name: 'Prior approved similar transaction using same cardholder account number', displayType: 'TEXT', columnKey: 'PriorSimilarTransaction', columnId: 'PriorSimilarTransaction', },     
    ],
      showActions: true,
      isExportable: true,
      canManageColumns: true,
      returnToText: 'Questionnaire Details',
      defaultSort: {
        key: 'caseNumber',
        order: 0,
      },
    }
  ].find((stageMetaData) => {
    return stageMetaData.id === id;
  });
}

export function getNewTabData(key, data) {
  return [
    {
      id: 3,
      key: 'authData',
      defaultIsVisible: false,
      title: 'Authorization Data',
      dataColumns: [{ defaultIsVisible: true, isDefault: true, description: 'Redacted Card Number', name: 'Redacted Card Number', displayType: 'ACCOUNTNUMBER', columnKey: 'cardNumberRk', secondaryColumnKey: 'globalToken', columnId: 'cardNumberRk', },
      { defaultIsVisible: true, isDefault: true, description: 'Merchant Number', name: 'Merchant Number', displayType: 'NUMBER', columnKey: 'merchantNumber', columnId: 'merchantNumber', },
      { defaultIsVisible: true, isDefault: true, description: 'Terminal Identifier', name: 'Terminal Identifier', displayType: 'STRING', columnKey: 'terminalId', columnId: 'terminalId', },
      { defaultIsVisible: true, isDefault: true, description: 'Authorization Amount', name: 'Authorization Amount', displayType: 'CURRENCY_UNIT', columnKey: 'authAmount', columnId: 'authAmount', },
      { defaultIsVisible: true, isDefault: true, description: 'Currency Code', name: 'Currency Code', displayType: 'STRING', columnKey: 'currencyCode', columnId: 'currencyCode', },
      { defaultIsVisible: true, isDefault: true, description: 'Authorization Code', name: 'Authorization Code', displayType: 'STRING', columnKey: 'authCode', columnId: 'authCode', },
      { defaultIsVisible: true, isDefault: true, description: 'Authorization Date', name: 'Authorization Date', displayType: 'DATE', columnKey: 'authDate', columnId: 'authDate', },
      { defaultIsVisible: true, isDefault: true, description: 'Authorization Time', name: 'Authorization Time', displayType: 'STRING', columnKey: 'authTime', columnId: 'authTime', },
      { defaultIsVisible: true, isDefault: true, description: 'Authorization Source', name: 'Authorization Source', displayType: 'STRING', columnKey: 'authSource', columnId: 'authSource', },
      { defaultIsVisible: true, isDefault: true, description: 'Transaction Code', name: 'Transaction Code', displayType: 'STRING', columnKey: 'tranCode', columnId: 'tranCode', },
      { defaultIsVisible: true, isDefault: true, description: 'Transaction Description', name: 'Transaction Description', displayType: 'STRING', columnKey: 'tranDesc', columnId: 'tranDesc', },
      { defaultIsVisible: true, isDefault: true, description: 'Transaction Identifier', name: 'Transaction Identifier', displayType: 'STRING', columnKey: 'tranId', columnId: 'tranId', },
      { defaultIsVisible: true, isDefault: true, description: 'Authorization Vendor', name: 'Authorization Vendor', displayType: 'STRING', columnKey: 'authVendor', columnId: 'authVendor', },
      { defaultIsVisible: true, isDefault: true, description: 'AVS Code', name: 'AVS Code', displayType: 'STRING', columnKey: 'avsCode', columnId: 'avsCode', },
      { defaultIsVisible: true, isDefault: true, description: 'Category Indicator', name: 'Category Indicator', displayType: 'STRING', columnKey: 'catInd', columnId: 'catInd', },
      { defaultIsVisible: true, isDefault: true, description: 'CAVV Results', name: 'CAVV Results', displayType: 'STRING', columnKey: 'cavvResults', columnId: 'cavvResults', },
      { defaultIsVisible: true, isDefault: true, description: 'CVV2 Results', name: 'CVV2 Results', displayType: 'STRING', columnKey: 'cvv2Results', columnId: 'cvv2Results', },
      { defaultIsVisible: true, isDefault: true, description: 'Issuer Response Code', name: 'Issuer Response Code', displayType: 'STRING', columnKey: 'issuerResponseCode', columnId: 'issuerResponseCode', },
      { defaultIsVisible: true, isDefault: true, description: 'Payment Service Indicator', name: 'Payment Service Indicator', displayType: 'STRING', columnKey: 'payServiceInd', columnId: 'payServiceInd', },
      { defaultIsVisible: true, isDefault: true, description: 'POS Entry Mode', name: 'POS Entry Mode', displayType: 'STRING', columnKey: 'posEntryMode', columnId: 'posEntryMode', },
      { defaultIsVisible: true, isDefault: true, description: 'POS Entry Mode Description', name: 'POS Entry Mode Description', displayType: 'STRING', columnKey: 'posEntryModeDesc', columnId: 'posEntryModeDesc', },
      { defaultIsVisible: true, isDefault: true, description: 'UCAF Indicator', name: 'UCAF Indicator', displayType: 'STRING', columnKey: 'ucafInd', columnId: 'ucafInd', },
      { defaultIsVisible: true, isDefault: true, description: 'Hierarchy', name: 'Hierarchy', displayType: 'STRING', columnKey: 'hierarchy', columnId: 'hierarchy', },
      ]
    },
    {
      id: 4,
      key: 'tranData',
      defaultIsVisible: false,
      title: 'Transaction Data',
      dataColumns: [{ defaultIsVisible: true, isDefault: true, name: 'Acquirer Reference Number', displayType: 'STRING', columnKey: 'arn', columnId: 'arn', },
      { defaultIsVisible: true, isDefault: true, name: 'Redacted Card Number', displayType: 'ACCOUNTNUMBER', columnKey: 'cardNumberRk', secondaryColumnKey: 'globalToken', columnId: 'cardNumberRk', },
      { defaultIsVisible: true, isDefault: true, name: 'Merchant Number', displayType: 'NUMBER', columnKey: 'merchantNumber', columnId: 'merchantNumber', },
      { defaultIsVisible: true, isDefault: true, name: 'Terminal Identifier', displayType: 'STRING', columnKey: 'terminalTid', columnId: 'terminalTid', },
      { defaultIsVisible: true, isDefault: true, name: 'Transaction Amount', displayType: 'CURRENCY_UNIT', columnKey: 'transactionAmount', columnId: 'transactionAmount', },
      { defaultIsVisible: true, isDefault: true, name: 'Currency Code', displayType: 'STRING', columnKey: 'currencyCode', columnId: 'currencyCode', },
      { defaultIsVisible: true, isDefault: true, name: 'Transaction Code', displayType: 'STRING', columnKey: 'transactionCode', columnId: 'transactionCode', },
      { defaultIsVisible: true, isDefault: true, name: 'Transaction Date', displayType: 'DATE', columnKey: 'transactionDate', columnId: 'transactionDate', },
      { defaultIsVisible: true, isDefault: true, name: 'Transaction Time', displayType: 'STRING', columnKey: 'transactionTime', columnId: 'transactionTime', },
      { defaultIsVisible: true, isDefault: true, name: 'Transaction Type', displayType: 'STRING', columnKey: 'transactionType', columnId: 'transactionType', },
      { defaultIsVisible: true, isDefault: true, name: 'Transaction Identifier', displayType: 'STRING', columnKey: 'transactionIdentifier', columnId: 'transactionIdentifier', },
      { defaultIsVisible: true, isDefault: true, name: 'Terminal Verification Result Code', displayType: 'STRING', columnKey: 'trmnlVerificationResultCode', columnId: 'trmnlVerificationResultCode', },
      { defaultIsVisible: true, isDefault: true, name: 'Authorization Amount', displayType: 'CURRENCY_UNIT', columnKey: 'authorizationAmount', columnId: 'authorizationAmount', },
      { defaultIsVisible: true, isDefault: true, name: 'Authorization Code', displayType: 'STRING', columnKey: 'authorizationCode', columnId: 'authorizationCode', },
      { defaultIsVisible: true, isDefault: true, name: 'Authorization Indicator', displayType: 'STRING', columnKey: 'authorizationInd', columnId: 'authorizationInd', },
      { defaultIsVisible: true, isDefault: true, name: 'Authorization Response Code', displayType: 'STRING', columnKey: 'authorizationResponseCode', columnId: 'authorizationResponseCode', },
      { defaultIsVisible: true, isDefault: true, name: 'Authorization Source Code', displayType: 'STRING', columnKey: 'authorizationSourceCode', columnId: 'authorizationSourceCode', },
      { defaultIsVisible: true, isDefault: true, name: 'Card Authentication Indicator', displayType: 'STRING', columnKey: 'cardAuthenticationInd', columnId: 'cardAuthenticationInd', },
      { defaultIsVisible: true, isDefault: true, name: 'Cardholder Id Method', displayType: 'STRING', columnKey: 'cardholderIdMethod', columnId: 'cardholderIdMethod', },
      { defaultIsVisible: true, isDefault: true, name: 'Cash Back Amount', displayType: 'CURRENCY_UNIT', columnKey: 'cashBackAmount', columnId: 'cashBackAmount', },
      { defaultIsVisible: true, isDefault: true, name: 'Category Indicator', displayType: 'STRING', columnKey: 'categoryInd', columnId: 'categoryInd', },
      { defaultIsVisible: true, isDefault: true, name: 'Cryptogram Code', displayType: 'STRING', columnKey: 'cryptogramCode', columnId: 'cryptogramCode', },
      { defaultIsVisible: true, isDefault: true, name: 'Cryptogram Information', displayType: 'STRING', columnKey: 'cryptogramInformation', columnId: 'cryptogramInformation', },
      { defaultIsVisible: true, isDefault: true, name: 'Cryptogram Unpredictable Nbr', displayType: 'STRING', columnKey: 'cryptogramUnpredictableNbr', columnId: 'cryptogramUnpredictableNbr', },
      { defaultIsVisible: true, isDefault: true, name: 'Currency Exponent', displayType: 'STRING', columnKey: 'currencyExponent', columnId: 'currencyExponent', },
      { defaultIsVisible: true, isDefault: true, name: 'Foreign Amount', displayType: 'CURRENCY_UNIT', columnKey: 'foreignAmount', columnId: 'foreignAmount', },
      { defaultIsVisible: true, isDefault: true, name: 'Foreign Domestic Indicator', displayType: 'STRING', columnKey: 'foreignDomesticInd', columnId: 'foreignDomesticInd', },
      { defaultIsVisible: true, isDefault: true, name: 'Invoice Number', displayType: 'NUMBER', columnKey: 'invoiceNumber', columnId: 'invoiceNumber', },
      { defaultIsVisible: true, isDefault: true, name: 'Issr Application Byte4to7 Data', displayType: 'STRING', columnKey: 'issrApplicationByte4to7Data', columnId: 'issrApplicationByte4to7Data', },
      { defaultIsVisible: true, isDefault: true, name: 'Issuer Application Byte1 Data', displayType: 'STRING', columnKey: 'issuerApplicationByte1Data', columnId: 'issuerApplicationByte1Data', },
      { defaultIsVisible: true, isDefault: true, name: 'Issuer Application Byte17 Data', displayType: 'STRING', columnKey: 'issuerApplicationByte17Data', columnId: 'issuerApplicationByte17Data', },
      { defaultIsVisible: true, isDefault: true, name: 'Issuer Application Byte2 Data', displayType: 'STRING', columnKey: 'issuerApplicationByte2Data', columnId: 'issuerApplicationByte2Data', },
      { defaultIsVisible: true, isDefault: true, name: 'Issuer Application Byte3 Data', displayType: 'STRING', columnKey: 'issuerApplicationByte3Data', columnId: 'issuerApplicationByte3Data', },
      { defaultIsVisible: true, isDefault: true, name: 'Issuer Application Byte8 Data', displayType: 'STRING', columnKey: 'issuerApplicationByte8Data', columnId: 'issuerApplicationByte8Data', },
      { defaultIsVisible: true, isDefault: true, name: 'Issuer Appln Byt18to32 Data', displayType: 'STRING', columnKey: 'issuerApplnByt18to32Data', columnId: 'issuerApplnByt18to32Data', },
      { defaultIsVisible: true, isDefault: true, name: 'Issuer Appln Byt9to16 Data', displayType: 'STRING', columnKey: 'issuerApplnByt9to16Data', columnId: 'issuerApplnByt9to16Data', },
      { defaultIsVisible: true, isDefault: true, name: 'MC Quick Payment Service Indicator', displayType: 'STRING', columnKey: 'mcQuickPaymentServiceInd', columnId: 'mcQuickPaymentServiceInd', },
      { defaultIsVisible: true, isDefault: true, name: 'Txn MCC', displayType: 'STRING', columnKey: 'mcc', columnId: 'mcc', },
      { defaultIsVisible: true, isDefault: true, name: 'MOTO Ecommerce Indicator', displayType: 'STRING', columnKey: 'motoEcInd', columnId: 'motoEcInd', },
      { defaultIsVisible: true, isDefault: true, name: 'Original Transaction Reference Number', displayType: 'STRING', columnKey: 'orgnlTransactionRefrncNbr', columnId: 'orgnlTransactionRefrncNbr', },
      { defaultIsVisible: true, isDefault: true, name: 'POS Entry Mode', displayType: 'STRING', columnKey: 'posEntryMode', columnId: 'posEntryMode', },
      { defaultIsVisible: true, isDefault: true, name: 'Recurring Payment Indicator', displayType: 'STRING', columnKey: 'recurringPayInd', columnId: 'recurringPayInd', },
      { defaultIsVisible: true, isDefault: true, name: 'Remarks', displayType: 'STRING', columnKey: 'remarks', columnId: 'remarks', },
      { defaultIsVisible: true, isDefault: true, name: 'Requested Payment Service Indicator', displayType: 'STRING', columnKey: 'requestedPaymentServiceInd', columnId: 'requestedPaymentServiceInd', },
      { defaultIsVisible: true, isDefault: true, name: 'Security Protocol', displayType: 'STRING', columnKey: 'securityProtocol', columnId: 'securityProtocol', },
      { defaultIsVisible: true, isDefault: true, name: 'Terminal Capability Profile', displayType: 'STRING', columnKey: 'terminalCapabilityProfile', columnId: 'terminalCapabilityProfile', },
      { defaultIsVisible: true, isDefault: true, name: 'Terminal Capacity Indicator', displayType: 'STRING', columnKey: 'terminalCapacityInd', columnId: 'terminalCapacityInd', },
      { defaultIsVisible: true, isDefault: true, name: 'Terminal Country Code', displayType: 'STRING', columnKey: 'terminalCountryCode', columnId: 'terminalCountryCode', },
      { defaultIsVisible: true, isDefault: true, name: 'Terminal Entry Mode', displayType: 'STRING', columnKey: 'terminalEntryMode', columnId: 'terminalEntryMode', },
      { defaultIsVisible: true, isDefault: true, name: 'Terminal Transaction Date', displayType: 'DATE', columnKey: 'terminalTransactionDate', columnId: 'terminalTransactionDate', },
      { defaultIsVisible: true, isDefault: true, name: 'Universal Cardholder Auth Field Indicator', displayType: 'STRING', columnKey: 'unvrslCardhldrAuthFieldInd', columnId: 'unvrslCardhldrAuthFieldInd', },
      { defaultIsVisible: true, isDefault: true, name: 'Global Transaction Id', displayType: 'STRING', columnKey: 'globalTransactionId', columnId: 'globalTransactionId', },
      { defaultIsVisible: true, isDefault: true, name: 'Payment Currency Alpha', displayType: 'STRING', columnKey: 'paymentCurrencyAlpha', columnId: 'paymentCurrencyAlpha', },
      { defaultIsVisible: true, isDefault: true, name: 'Front End Vendor Desc', displayType: 'STRING', columnKey: 'frontEndVendorIdDesc', columnId: 'frontEndVendorIdDesc', },
      ],
    },
    {
      id: 2,
      key: 'schemeData',
      defaultIsVisible: false,
      title: 'Card Brand Data',
      dataColumns: getDataColumnsForScheme(data),
    },
    {
      id: 1,
      key: 'caseData',
      defaultIsVisible: false,
      title: 'Case Data',
      dataColumns: [
        { defaultIsVisible: true, isDefault: true, description: 'Acquirer BIN/ICA', name: 'Acquirer BIN/ICA', displayType: 'STRING', columnKey: 'acquirerBinIca', columnId: 'acquirerBinIca', },
        { defaultIsVisible: true, isDefault: true, description: 'Acquirer Name', name: 'Acquirer Name', displayType: 'STRING', columnKey: 'acquirerName', columnId: 'acquirerName', },
        { defaultIsVisible: true, isDefault: true, description: 'Acquirer Reference Number', name: 'Acquirer Reference Number', displayType: 'NUMBER', columnKey: 'acquirerReferenceNumber', columnId: 'acquirerReferenceNumber', },
        { defaultIsVisible: true, isDefault: true, description: 'Authorization Code', name: 'Authorization Code', displayType: 'NUMBER', columnKey: 'authorizationCode', columnId: 'authorizationCode', },
        { defaultIsVisible: true, isDefault: true, description: 'Card Brand Code', name: 'Card Brand Code', displayType: 'card_type', columnKey: 'cardBrandCode', columnId: 'cardBrandCode', },
        { defaultIsVisible: true, isDefault: true, description: 'Card Brand Region Code', name: 'Card Brand Region Code', displayType: 'STRING', columnKey: 'cardBrandRegionCode', columnId: 'cardBrandRegionCode', },
        { defaultIsVisible: true, isDefault: true, description: 'Created By', name: 'Created By', displayType: 'STRING', columnKey: 'createdBy', columnId: 'createdBy', },
        { defaultIsVisible: true, isDefault: true, description: 'Created Timestamp', name: 'Created Timestamp', displayType: 'DATE', columnKey: 'createdTimestamp', columnId: 'createdTimestamp', },
        { defaultIsVisible: true, isDefault: true, description: 'Dispute Currency Code', name: 'Dispute Currency Code', displayType: 'STRING', columnKey: 'disputeCurrencyCode', columnId: 'disputeCurrencyCode', },
        { defaultIsVisible: true, isDefault: true, description: 'Dspt To Mrchnt Cur Exchng Rate', name: 'Dspt To Mrchnt Cur Exchng Rate', displayType: 'STRING', columnKey: 'dsptToMrchntCurExchngRate', columnId: 'dsptToMrchntCurExchngRate', },
        { defaultIsVisible: true, isDefault: true, description: 'Foreign Domestic Indicator', name: 'Foreign Domestic Indicator', displayType: 'NUMBER', columnKey: 'foreignDomesticIndicator', columnId: 'foreignDomesticIndicator', },
        { defaultIsVisible: true, isDefault: true, description: 'Global Token', name: 'Global Token', displayType: 'STRING', columnKey: 'globalToken', columnId: 'globalToken', },
        { defaultIsVisible: true, isDefault: true, description: 'Issuer Bin Ica', name: 'Issuer Bin Ica', displayType: 'STRING', columnKey: 'issuerBinIca', columnId: 'issuerBinIca', },
        { defaultIsVisible: true, isDefault: true, description: 'Last Modified By', name: 'Last Modified By', displayType: 'STRING', columnKey: 'lastModifiedBy', columnId: 'lastModifiedBy', },
        { defaultIsVisible: true, isDefault: true, description: 'Last Modified Timestamp', name: 'Last Modified Timestamp', displayType: 'DATE', columnKey: 'lastModifiedTimestamp', columnId: 'lastModifiedTimestamp', },
        { defaultIsVisible: true, isDefault: true, description: 'MAS Hierarchy Id', name: 'MAS Hierarchy Id', displayType: 'NUMBER', columnKey: 'masHierarchyId', columnId: 'masHierarchyId', },
        { defaultIsVisible: true, isDefault: true, description: 'Masked Card Number', name: 'Masked Card Number', displayType: 'ACCOUNTNUMBER', secondaryColumnKey: 'globalToken', columnKey: 'maskedCardNumber', columnId: 'maskedCardNumber', },
        { defaultIsVisible: true, isDefault: true, description: 'Merchant Category Code', name: 'Merchant Category Code', displayType: 'STRING', columnKey: 'merchantCategoryCode', columnId: 'merchantCategoryCode', },
        { defaultIsVisible: true, isDefault: true, description: 'Merchant City', name: 'Merchant City', displayType: 'STRING', columnKey: 'merchantCity', columnId: 'merchantCity', },
        { defaultIsVisible: true, isDefault: true, description: 'Merchant Country Code', name: 'Merchant Country Code', displayType: 'STRING', columnKey: 'merchantCountryCode', columnId: 'merchantCountryCode', },
        { defaultIsVisible: true, isDefault: true, description: 'Merchant Hierarchy Id', name: 'Merchant Hierarchy Id', displayType: 'STRING', columnKey: 'merchantHeirarchyId', columnId: 'merchantHeirarchyId', },
        { defaultIsVisible: true, isDefault: true, description: 'Merchant Name', name: 'Merchant Name', displayType: 'STRING', columnKey: 'merchantName', columnId: 'merchantName', },
        { defaultIsVisible: true, isDefault: true, description: 'Merchant Payment Currency Code', name: 'Merchant Payment Currency Code', displayType: 'STRING', columnKey: 'merchantPaymentCurrencyCode', columnId: 'merchantPaymentCurrencyCode', },
        { defaultIsVisible: true, isDefault: true, description: 'Merchant Region Code', name: 'Merchant Region Code', displayType: 'STRING', columnKey: 'merchantRegionCode', columnId: 'merchantRegionCode', },
        { defaultIsVisible: true, isDefault: true, description: 'Merchant Token', name: 'Merchant Token', displayType: 'STRING', columnKey: 'merchantToken', columnId: 'merchantToken', },
        { defaultIsVisible: true, isDefault: true, description: 'Mrchnt To Dspt Cur Exchng Rate', name: 'Mrchnt To Dspt Cur Exchng Rate', displayType: 'STRING', columnKey: 'mrchntToDsptCurExchngRate', columnId: 'mrchntToDsptCurExchngRate', },
        { defaultIsVisible: true, isDefault: true, description: 'Settlement Bank Id', name: 'Settlement Bank Id', displayType: 'NUMBER', columnKey: 'settlementBankId', columnId: 'settlementBankId', },
        { defaultIsVisible: true, isDefault: true, description: 'Settlement Company Number', name: 'Settlement Company Number', displayType: 'STRING', columnKey: 'settlementCompanyNumber', columnId: 'settlementCompanyNumber', },
        { defaultIsVisible: true, isDefault: true, description: 'Transaction Amount', name: 'Transaction Amount', displayType: 'CURRENCY_UNIT', columnKey: 'transactionAmount', columnId: 'transactionAmount', },
        { defaultIsVisible: true, isDefault: true, description: 'Transaction Currency Code', name: 'Transaction Currency Code', displayType: 'STRING', columnKey: 'transactionCurrencyCode', columnId: 'transactionCurrencyCode', },
        { defaultIsVisible: true, isDefault: true, description: 'Transaction Date', name: 'Transaction Date', displayType: 'DATE', columnKey: 'transactionDate', columnId: 'transactionDate', },
        { defaultIsVisible: true, isDefault: true, description: 'Transaction Master Id', name: 'Transaction Master Id', displayType: '', columnKey: 'transactionMasterId', columnId: 'transactionMasterId', },
        { defaultIsVisible: true, isDefault: true, description: 'Transaction Time', name: 'Transaction Time', displayType: 'STRING', columnKey: 'transactionTime', columnId: 'transactionTime', },
        { defaultIsVisible: true, isDefault: true, description: 'Card Brand Case Number', name: 'Card Brand Case Number', displayType: 'NUMBER', columnKey: 'cardBrandCaseNumber', columnId: 'cardBrandCaseNumber', },
        { defaultIsVisible: true, isDefault: true, description: 'Card Brand Dispute Id', name: 'Card Brand Dispute Id', displayType: 'STRING', columnKey: 'cardBrandDisputeId', columnId: 'cardBrandDisputeId', },
        { defaultIsVisible: true, isDefault: true, description: 'Card Brand Merchant Number', name: 'Card Brand Merchant Number', displayType: 'NUMBER', columnKey: 'cardBrandMerchantNumber', columnId: 'cardBrandMerchantNumber', },
        { defaultIsVisible: true, isDefault: true, description: 'Card Brand Respond Due Date', name: 'Card Brand Respond Due Date', displayType: 'DATE', columnKey: 'cardBrandRespondDueDate', columnId: 'cardBrandRespondDueDate', },
        { defaultIsVisible: true, isDefault: true, description: 'Case Number', name: 'Case Number', displayType: 'NUMBER', columnKey: 'caseNumber', columnId: 'caseNumber', },
        { defaultIsVisible: true, isDefault: true, description: 'Case Received Date', name: 'Case Received Date', displayType: 'DATE', columnKey: 'caseReceivedDate', columnId: 'caseReceivedDate', },
        { defaultIsVisible: true, isDefault: true, description: 'Case Result', name: 'Case Result', displayType: 'STRING', columnKey: 'caseResult', columnId: 'caseResult', },
        { defaultIsVisible: true, isDefault: true, description: 'Case Stage Id', name: 'Case Stage Id', displayType: 'NUMBER', columnKey: 'caseStageId', columnId: 'caseStageId', },
        { defaultIsVisible: true, isDefault: true, description: 'Case Workflow Config Id', name: 'Case Workflow Config Id', displayType: 'NUMBER', columnKey: 'caseWorkflowConfigId', columnId: 'caseWorkflowConfigId', },
        { defaultIsVisible: true, isDefault: true, description: 'Credit Debit Ind', name: 'Credit Debit Ind', displayType: 'STRING', columnKey: 'creditDebitInd', columnId: 'creditDebitInd', },
        { defaultIsVisible: true, isDefault: true, description: 'Credited Amount', name: 'Credited Amount', displayType: 'CURRENCY_UNIT', columnKey: 'creditedAmount', columnId: 'creditedAmount', },
        { defaultIsVisible: true, isDefault: true, description: 'Credited Date', name: 'Credited Date', displayType: 'DATE', columnKey: 'creditedDate', columnId: 'creditedDate', },
        { defaultIsVisible: true, isDefault: true, description: 'Disposition Action Code', name: 'Disposition Action Code', displayType: 'STRING', columnKey: 'dispositionActionCode', columnId: 'dispositionActionCode', },
        { defaultIsVisible: true, isDefault: true, description: 'Disposition Activity Code', name: 'Disposition Activity Code', displayType: 'STRING', columnKey: 'dispositionActivityCode', columnId: 'dispositionActivityCode', },
        { defaultIsVisible: true, isDefault: true, description: 'Dispute Amount', name: 'Dispute Amount', displayType: 'CURRENCY_UNIT', columnKey: 'disputeAmount', columnId: 'disputeAmount', },
        { defaultIsVisible: true, isDefault: true, description: 'Dispute Reason Code', name: 'Dispute Reason Code', displayType: 'STRING', columnKey: 'disputeReasonCode', columnId: 'disputeReasonCode', },
        { defaultIsVisible: true, isDefault: true, description: 'Dispute Source Id', name: 'Dispute Source Id', displayType: 'STRING', columnKey: 'disputeSourceId', columnId: 'disputeSourceId', },
        { defaultIsVisible: true, isDefault: true, description: 'Dispute Stage Id', name: 'Dispute Stage Id', displayType: 'STRING', columnKey: 'disputeStageId', columnId: 'disputeStageId', },
        { defaultIsVisible: true, isDefault: true, description: 'Gl Adjust Status', name: 'Gl Adjust Status', displayType: 'STRING', columnKey: 'glAdjustStatus', columnId: 'glAdjustStatus', },
        { defaultIsVisible: true, isDefault: true, description: 'Delay Debit Ind', name: 'Delay Debit Ind', displayType: 'STRING', columnKey: 'hpyDelayDebitInd', columnId: 'hpyDelayDebitInd', },
        { defaultIsVisible: true, isDefault: true, description: 'Internal Respond Due Date', name: 'Internal Respond Due Date', displayType: 'DATE', columnKey: 'internalRespondDueDate', columnId: 'internalRespondDueDate', },
        { defaultIsVisible: true, isDefault: true, description: 'Is Decision Confirmed Ind', name: 'Is Decision Confirmed Ind', displayType: 'STRING', columnKey: 'isDecisionConfirmedInd', columnId: 'isDecisionConfirmedInd', },
        { defaultIsVisible: true, isDefault: true, description: 'Latest Stage Ind', name: 'Latest Stage Ind', displayType: 'STRING', columnKey: 'latestStageInd', columnId: 'latestStageInd', },
        { defaultIsVisible: true, isDefault: true, description: 'Member Message Text', name: 'Member Message Text', displayType: 'STRING', columnKey: 'memberMessageText', columnId: 'memberMessageText', },
        { defaultIsVisible: true, isDefault: true, description: 'Merchant Disposition Actn Code', name: 'Merchant Disposition Actn Code', displayType: 'STRING', columnKey: 'merchantDispositionActnCode', columnId: 'merchantDispositionActnCode', },
        { defaultIsVisible: true, isDefault: true, description: 'Merchant Payment Amount', name: 'Merchant Payment Amount', displayType: 'CURRENCY_UNIT', columnKey: 'merchantPaymentAmount', columnId: 'merchantPaymentAmount', },
        { defaultIsVisible: true, isDefault: true, description: 'Merchant Respond Due Date', name: 'Merchant Respond Due Date', displayType: 'DATE', columnKey: 'merchantRespondDueDate', columnId: 'merchantRespondDueDate', },
        { defaultIsVisible: true, isDefault: true, description: 'Merchant Status Id', name: 'Merchant Status Id', displayType: 'STRING', columnKey: 'merchantStatusId', columnId: 'merchantStatusId', },
        { defaultIsVisible: true, isDefault: true, description: 'Partial Indicator', name: 'Partial Indicator', displayType: 'STRING', columnKey: 'partialInd', columnId: 'partialInd', },
        { defaultIsVisible: true, isDefault: true, description: 'Pend Indicator', name: 'Pend Indicator', displayType: 'STRING', columnKey: 'pendInd', columnId: 'pendInd', },
        { defaultIsVisible: true, isDefault: true, description: 'Queue Id', name: 'Queue Id', displayType: 'STRING', columnKey: 'queueId', columnId: 'queueId', },
        { defaultIsVisible: true, isDefault: true, description: 'Representment Amount', name: 'Representment Amount', displayType: 'CURRENCY_UNIT', columnKey: 'representmentAmount', columnId: 'representmentAmount', },
        { defaultIsVisible: true, isDefault: true, description: 'Response To Case Stage Id', name: 'Response To Case Stage Id', displayType: 'STRING', columnKey: 'responseToCaseStageId', columnId: 'responseToCaseStageId', },
        { defaultIsVisible: true, isDefault: true, description: 'Stage Config Id', name: 'Stage Config Id', displayType: 'STRING', columnKey: 'stageConfigId', columnId: 'stageConfigId', },
        { defaultIsVisible: true, isDefault: true, description: 'Status Id', name: 'Status Id', displayType: 'STRING', columnKey: 'statusId', columnId: 'statusId', },
        { defaultIsVisible: true, isDefault: true, description: 'Support Document Ind', name: 'Support Document Ind', displayType: 'INDICATOR', columnKey: 'supportDocumentInd', columnId: 'supportDocumentInd', },
        { defaultIsVisible: true, isDefault: true, description: 'Take Action Code', name: 'Take Action Code', displayType: 'STRING', columnKey: 'takeActionCode', columnId: 'takeActionCode', },
      ]
    },
  ].find((stageMetaData) => {
    return stageMetaData.key === key;
  });
}
export function getOp1CaseDetails() {
  return {
    dataColumns: [
      {
        description: '',
        isRequired: false,
        isSortable: false,
        inputType: 'Text',
        columnKey: 'cardBrandMerchantNumber',
        title: 'Industry SE Number',
        inputBoxWidth: '345px',
        disabled: true,
        errorMsg: '',
      },
      {
        description: '',
        isRequired: true,
        isSortable: false,
        inputType: 'Text',
        columnKey: 'sellerId',
        title: 'Seller ID',
        inputBoxWidth: '345px',
        max: 20,
        validate: alphaNumeric,
        errorMsg: '',
      },
      {
        description: '',
        isRequired: true,
        isSortable: false,
        inputType: 'Text',
        columnKey: 'cardNumber',
        title: 'Card Number',
        inputBoxWidth: '345px',
        max: 19,
        validate: numeric,
        errorMsg: '',
      },
      {
        description: '',
        isRequired: true,
        isSortable: false,
        inputType: 'Text',
        columnKey: 'cardBrandCaseNumber',
        title: 'Amex Case Number',
        inputBoxWidth: '345px',
        max: 11,
        validate: (value) => alphaNumeric(value, '-'),
        errorMsg: '',
      },
      {
        description: '',
        isRequired: true,
        isSortable: false,
        inputType: 'Date',
        dateFormat: 'MM/DD/YYYY',
        columnKey: 'transactionDate',
        title: 'Charge Date',
        inputBoxWidth: '345px',
        errorMsg: '',
      },
      {
        description: '',
        isRequired: true,
        isSortable: false,
        inputType: 'Date',
        dateFormat: 'MM/DD/YYYY',
        columnKey: 'caseReceivedDate',
        title: 'Adjustment Date',
        inputBoxWidth: '345px',
        errorMsg: '',
      },
      {
        description: '',
        isRequired: true,
        isSortable: false,
        inputType: 'Text',
        columnKey: 'transactionAmount',
        title: 'Transaction Amount (USD)',
        inputBoxWidth: '345px',
        max: 18,
        validate: (value) => decimalNumber(value, 17),
        errorMsg: '',
      },
      {
        description: '',
        isRequired: true,
        isSortable: false,
        inputType: 'Text',
        columnKey: 'disputeAmount',
        title: 'Adjustment Amount (USD)',
        inputBoxWidth: '345px',
        max: 18,
        validate: (value) => decimalNumber(value, 17),
        errorMsg: '',
      },
      {
        description: '',
        isRequired: true,
        isSortable: false,
        inputType: 'Text',
        columnKey: 'disputeReasonCode',
        title: 'Reason Code',
        inputBoxWidth: '345px',
        max: 3,
        min: 3,
        validate: alphaNumeric,
        errorMsg: '',
      },
      {
        description: '',
        isRequired: true,
        isSortable: false,
        inputType: 'Text',
        columnKey: 'acquirerReferenceNumber',
        title: 'Acquirer Reference Number',
        inputBoxWidth: '345px',
        max: 30,
        validate: numeric,
        errorMsg: '',
      },
      {
        description: '',
        isRequired: true,
        isSortable: false,
        inputType: 'Text',
        columnKey: 'memberMessageText',
        title: 'Notes',
        inputBoxWidth: '705px',
        max: 6500,
        errorMsg: '',
      },
    ],
    title: '',
    primaryActionButtonText: 'Submit',
    primaryButtonType: 'primary',
    secondaryButtonType: 'hollow',
    wrapperWidth: '100%',
    formWidth: '100%',
    inputBoxWidth: '345px',
    textAreaWidth: '1050px',
    dateFormatForApi: 'YYYY-MM-DD',
    buttonStyle: {
      paddingLeft: '3%',
      paddingRight: '3%',
      float: 'right',
      marginRight: '16px'
    },
    cancelButtonStyle: {
      paddingLeft: '3%',
      paddingRight: '3%',
      marginLeft: '16px'
    },
    formGroupExtraStyle: {
      marginTop: '-30px',
      paddingRight: '0px',
      padding: '0px',
      paddingTop: '10px'
    },
    formWrapperStyle: {
      paddingLeft: 'unset'
    }
  };
}


export function getWexCaseDetails() {
  return {
    dataColumns: [
      
      {
        description: '',
        isRequired: true,
        isSortable: false,
        inputType: 'Text',
        columnKey: 'acquirerReferenceNumber',
        title: 'Acquirer Reference Number',
        inputBoxWidth: '345px',
      },
      {
        description: '',
        isRequired: false,
        isSortable: false,
        inputType: 'Text',
        columnKey: 'notes',
        title: 'Notes',
        inputBoxWidth: '1065px',
      },

    ],
    title: '',
    primaryActionButtonText: 'Submit',
    primaryButtonType: 'primary',
    secondaryButtonType: 'hollow',
    wrapperWidth: '100%',
    formWidth: '100%',
    inputBoxWidth: '345px',
    textAreaWidth: '1050px',
    dateFormatForApi: 'YYYY-MM-DD',
    buttonStyle: {
      paddingLeft: '3%',
      paddingRight: '3%',
      float: 'right',
      marginRight: '16px'
    },
    cancelButtonStyle: {
      paddingLeft: '3%',
      paddingRight: '3%',
      marginLeft: '16px'
    },
    formGroupExtraStyle: {
      marginTop: '-30px',
      paddingRight: '0px',
      padding: '0px',
      paddingTop: '10px'
    },
    formWrapperStyle: {
      paddingLeft: 'unset'
    }
  };
}
export function getLTypeCaseDetails() {
  return {
    dataColumns: [
      {
        description: '',
        isRequired: true,
        isSortable: false,
        inputType: 'DropDown',
        columnKey: 'disputeStage',
        title: 'Dispute Stage',
        inputBoxWidth: '345px',
        list: [
          { text: 'First Chargeback', value: 'fc' }, { text: 'Second Chargeback', value: 'sc' }
        ]
      },
      {
        description: '',
        isRequired: false,
        isSortable: false,
        inputType: 'Text',
        columnKey: 'notes',
        title: 'Notes',
        inputBoxWidth: '1065px',
      },

    ],
    title: '',
    primaryActionButtonText: 'Submit',
    primaryButtonType: 'primary',
    secondaryButtonType: 'hollow',
    wrapperWidth: '100%',
    formWidth: '100%',
    formMarginBottom: '-60px',
    inputBoxWidth: '345px',
    textAreaWidth: '1050px',
    dateFormatForApi: 'YYYY-MM-DD',
    buttonStyle: {
      paddingLeft: '3%',
      paddingRight: '3%',
      float: 'right',
      marginRight: '16px'
    },
    cancelButtonStyle: {
      paddingLeft: '3%',
      paddingRight: '3%',
      marginLeft: '16px'
    },
    formGroupExtraStyle: {
      marginTop: '-30px',
      paddingRight: '0px',
      padding: '0px',
      paddingTop: '10px'
    },
    formGroupExtraStyleUnIdentified: {
      marginTop: '0px',
      paddingRight: '0px',
      padding: '0px',
      paddingTop: '10px'
    },
    formWrapperStyle: {
      paddingLeft: 'unset'
    }
  };
}

export const NON_TAKE_ACTION_QUEUES = [6, 7, 8];

export function getTranslations() {
  return ({
    actionCode: 'Search Action Code',
    activityCode: 'Search Activity Code',
    disputeCurrency: 'Search Dispute Currency',
    trnsctnCurrency: 'Search Transaction Currency',
    sttlmntCrrncy: 'Search Settlement Currency',
    dspstnCtgry: 'Search Disposition Category',
    mcc: 'Search MCC',
    corpAndRegion: 'Search Corp and Region',
    reasonCode: 'Search Reason Code',
    applyFilterPane: 'Search',
    cancel: 'Cancel',
    clearFilterPane: 'Clear',
    less: 'Less',
    more: 'More',
    save: 'Save',
    select: 'Select',
    dates: {
      apply: 'Apply',
      cancel: 'Cancel',
      custom: 'Custom',
      fri: 'Fri',
      from: 'From',
      lastMonth: 'Last Month',
      lastSevenDays: 'Last 7 Days',
      lastThirtyDays: 'Last 30 Days',
      lastWeek: 'Last Week',
      lastYear: 'Select Date(s)',
      mon: 'Mon',
      sat: 'Sat',
      sun: 'Sun',
      thisMonth: 'This Month',
      thisYear: 'This Year',
      thu: 'Thu',
      to: 'To',
      tue: 'Tue',
      unselectedText: 'Select Date(s)',
      validDateError: 'Please enter a valid date.',
      wed: 'Wed',
      yesterday: 'Yesterday',
      jan: 'January',
      feb: 'February',
      mar: 'March',
      apr: 'April',
      may: 'May',
      jun: 'June',
      jul: 'July',
      aug: 'August',
      sep: 'September',
      oct: 'October',
      nov: 'November',
      dec: 'December',
    },
    actions: 'Actions',
    active: 'Active',
    addAll: 'Add All',
    apply: 'Apply',
    applyFilterPane: 'Apply',
    backLinkText: 'Back to Reports',
    cancel: 'Cancel',
    clearAll: 'Clear All',
    clear: 'Reset',
    columns: 'Columns',
    createAFilterContent: 'To select a filter, please create a filter.',
    createAFilterTitle: 'Start by creating a filter',
    currency: 'Currency',
    export: 'Export',
    exporting: 'Exporting',
    exportTypesTitle: 'What do you want to export?',
    fileName: 'Name of file:',
    fileTypesTitle: 'Export As:',
    fileNameLabel: 'Name of File:',
    filterPaneTriggerText: 'Filter',
    filters: 'Filters',
    header: 'Export Data',
    hideAll: 'Hide All',
    inactive: 'Inactive',
    less: 'Less',
    more: 'More',
    next: 'Next',
    prev: 'Previous',
    page: 'Page',
    placeholder: 'Search by Filter Name...',
    preposition: 'of',
    removeAll: 'Remove All',
    save: 'Save',
    savedFilters: 'Saved Filters',
    searchCurrencies: 'Search Currencies',
    shareReport: 'Share Report',
    showAll: 'Show All',
    show5perPage: 'Show 5 per page',
    show10perPage: 'Show 10 per page',
    show15perPage: 'Show 15 per page',
    show20perPage: 'Show 20 per page',
    showingRecords: 'Showing records',
    paginationDropdownoptions: [
      { value: 5, text: "Show 5 per page" },
      { value: 10, text: "Show 10 per page" },
      { value: 15, text: "Show 15 per page" },
      {  value: 20,  text: "Show 20 per page" },
    ],
    summaryTitle: 'Summary',
    title: 'Saved Filters',
    saveFilterLabel: 'Filter Name',
    saveFilterTitle: 'Save Filter',
    availableColumns: 'Available Columns',
    availableFilterText: 'Available Filters',
    searchAvailableFilters: 'Search Report Filters',
    searchAvailableColumns: 'Search Available Columns',
    activeColumns: 'Active Columns',
    selected: 'Selected',
    searchActiveColumns: 'Search Active Columns',
    cardNum: 'Account Number (first 6 or last 4 digits)',
    helperText: '(first 6 or last 4 digits)',
    first6Placeholder: counterpart('globalTranslate.queues.firstSix'),
    last4Placeholder: counterpart('globalTranslate.queues.lastFour'),
    searchReasonCodePlaceholder: counterpart('globalTranslate.caseSearch.searchReasonCode'),
  });
}

export function getRelatedCasesFilterList() {
  return {
    name: 'Related Cases Results',
    headerName: 'Related Cases',
    pageId: 'related_cases',
    canManageColumns: true,
    dataColumns: [],
    elementIDs: [
      {
        columnKey: 'caseNumber',
        elementId: 'case_number',
      },
      {
        columnKey: 'maskedCardNumber',
        elementId: 'case_first_six_mask-case_last_four_mask',
      },
      {
        columnKey: 'merchantName',
        elementId: 'merchant_name',
      },
      {
        columnKey: 'cardBrandCode',
        elementId: 'case_card_brand',
      },
      {
        columnKey: 'disputeReasonCode',
        elementId: 'case_reason_code',
      },
      {
        columnKey: 'disputeAmount',
        elementId: 'case_from_dispt_amt-case_to_dispt_amt',
      },
      {
        columnKey: 'disputeStatus',
        elementId: 'case_status',
      },
      {
        columnKey: 'acquirerBinIca',
        elementId: 'case_acquirer_bin',
      },
      {
        columnKey: 'acquirerReferenceNumber',
        elementId: 'case_arn',
      },
      {
        columnKey: 'issuerBinIca',
        elementId: 'case_issuer_bin',
      },
      {
        columnKey: 'tranAmount',
        elementId: 'case_trans_amount',
      },
      {
        columnKey: 'transactionDate',
        elementId: 'case_trans_from_date-case_trans_to_date',
      },
      {
        columnKey: 'tranTime',
        elementId: 'case_trans_date',
      },
      {
        columnKey: 'disputeStageName',
        elementId: 'case_type',
      },
      {
        columnKey: 'cardBrandRegionCode',
        elementId: 'case_zone',
      },
      {
        columnKey: 'glCompanyName',
        elementId: 'case_gl_company',
      },
      {
        columnKey: 'codeDescription',
        elementId: 'case_trans_date',
      },
      {
        columnKey: 'cardBrandRegionCode',
        elementId: 'case_status',
      },
      {
        columnKey: 'merchantNumber',
        elementId: 'case_merch_number',
      },
      {
        columnKey: 'dueDate',
        elementId: 'case_from_due_date-case_to_due_date',
      },
      {
        columnKey: 'disputeAmount',
        elementId: 'dispute_amt_from-dispute_amt_to',
      },
      {
        columnKey: 'globalTransactionId',
        elementId: 'global_transaction_id',
      },
      {
        columnKey: "legalName",
        elementId: "legal_name"
      },
      {
        columnKey: "hpyPetroName",
        elementId: "hpy_petro_name"
      },
      {
        columnKey: "mccCode",
        elementId: "mcc_code"
      },
      {
        columnKey: "mcc",
        elementId: "transaction_mcc"
      },
      {
        columnKey: "caseReceivedDate",
        elementId: "case_rcvd_from_date-case_rcvd_to_date"
      },
      {
        columnKey: "posEntryMode",
        elementId: "pos_entry_mode"
      },
      {
        columnKey: "chargebackUsageCode",
        elementId: "chargeback_usage_code"
      },
      {
        columnKey: "merchantDraftChargeback",
        elementId: "merchant_draft_chargeback"
      },
      {
        columnKey: "chargebackReferenceNumber",
        elementId: "chargeback_ref_number"
      },
    ],
    actions: [
      {
        title: 'Open Case',
        url: 'landing',
        key: 'OPEN_CASE',
        style: {
          paddingRight: '60px',
          paddingLeft: '0px',
          width: '150px',
        },
      }
    ],
    defaultSort: [
      {
        key: 'dueDate',
        order: 1,
      },
      {
        key: 'disputeAmount',
        order: 0,
      }]
    ,
    dateFormat: 'MM/DD/YYYY',
    pageSize: 5,
  };
}
